<template>
    <div>
        <v-dialog
            v-model="dialogVisible"
            persistent
            max-width="1300px"
            scrollable
            fullscreen
        >
            <v-card class="modern-modal">
            <!-- Header mejorado -->
            <v-card-title class="header-gradient white--text pa-4 elevation-2">
                <div class="d-flex align-center">
                <v-icon class="mr-3" large dark>mdi-clipboard-text-outline</v-icon>
                <div>
                    <h3 class="mb-0">{{ isEdit ? 'Editar' : 'Nueva' }} Visita Técnica</h3>
                    <p class="mb-0 text-caption opacity-80">
                    {{ isEdit ? 'Actualizar información de visita' : 'Registrar nueva visita técnica' }}
                    </p>
                </div>
                </div>
                <v-spacer></v-spacer>
                <v-btn icon dark @click="closeModal" class="ml-2">
                <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text class="pa-0">
                <v-form ref="form" v-model="valid">
                <div class="form-container">
                    
                    <!-- Información del Documento - Compacto -->
                    <div class="section-card">
                    <div class="section-header">
                        <v-icon class="mr-2 text--secondary">mdi-file-document-outline</v-icon>
                        <h4 class="section-title">Información del Documento</h4>
                    </div>
                    <v-row class="section-content">
                        <v-col cols="12" sm="6" md="3">
                        <s-date
                            label="Fecha*"
                            v-model="formData.VstDate"
                            :max="$fun.getDate(0)"
                            :rules="[v => !!v || 'La fecha es requerida']"
                            @input="onDateChange"
                            outlined
                            dense
                        />
                        </v-col>
                        <!-- <v-col cols="12" sm="3" md="2">
                          <s-text
                            label="Latitud"
                            v-model="location.latitude"
                            readonly
                            outlined
                            dense
                          />
                        </v-col>
                        <v-col cols="12" sm="3" md="2">
                          <s-text
                            label="Longitud"
                            v-model="location.longitude"
                            readonly
                            outlined
                            dense
                          />
                        </v-col> -->
                        <v-col cols="12" sm="3" md="2">
                        <s-text
                            label="Serie*"
                            v-model="formData.VstSerie"
                            number
                            outlined
                            dense
                        />
                        </v-col>
                        <v-col cols="12" sm="3" md="2">
                        <s-text
                            label="Número*"
                            v-model="formData.VstNumber"
                            number
                            outlined
                            dense
                        />
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                        <s-select-supervice
                            label="Supervisor*"
                            v-model="formData.VstSupervisorPrsID"
                            :rules="[v => !!v || 'El supervisor es requerido']"
                            clearable
                            full
                            outlined
                            dense
                        />
                        </v-col>
                        <v-col cols="12" sm="6" md="1">
                        <s-text
                            label="ID Prog."
                            v-model="formData.TvID"
                            number
                            outlined
                            dense
                        />
                        </v-col>

                        <v-col cols="12" sm="12" md="12" v-if="loadingLocation">
                          <div class="location-loader-container">
                            <div class="pulse-loader">
                              <div class="pulse-dot"></div>
                              <div class="pulse-ring"></div>
                              <div class="pulse-ring"></div>
                              <div class="pulse-ring"></div>
                            </div>
                            <p class="loader-text">Obteniendo tu ubicación...</p>
                          </div>
                        </v-col>
                    </v-row>
                    </div>

                    <!-- Búsqueda de Lote -->
                    <div class="section-card">
                    <div class="section-header">
                        <v-icon class="mr-2 text--secondary">mdi-map-marker-outline</v-icon>
                        <h4 class="section-title">Información del Lote</h4>
                    </div>
                    
                    <!-- Búsqueda -->
                    <v-row class="section-content">
                        <v-col cols="12" md="6">
                          <s-search-lot-by-cod-senasa
                              ref="searchLotSenasa"
                              @searchSenasa="searchSenasa($event)"
                          />
                        </v-col>
                        <v-col cols="12" md="3">
                        <s-text
                            label="ID Lote"
                            v-model="lotInfo.FltID"
                            readonly
                            outlined
                            dense
                        />
                        </v-col>
                        <v-col cols="12" md="3">
                        <s-select-campaign-area
                            label="Campaña"
                            v-model="formData.GenID"
                            typeArea="1"
                            :typeCultive="lotInfo.TypeCultive ? lotInfo.TypeCultive.toString() : '0'"
                            clearable
                            full
                            outlined
                            dense
                        />
                        </v-col>
                    </v-row>

                    <!-- Información del Lote en Cards -->
                    <v-row class="section-content mt-0" v-if="lotInfo.FltID">
                        <v-col cols="12" md="3">
                          <div class="info-card">
                              <div class="info-header">
                              <v-icon small class="mr-2">mdi-information-outline</v-icon>
                              <span class="info-title">Datos del Lote</span>
                              </div>
                              <div class="info-content">
                              <div class="info-row">
                                  <span class="info-label">Nombre:</span>
                                  <span class="info-value">{{ lotInfo.FltName }}</span>
                              </div>
                              <div class="info-row">
                                  <span class="info-label">Variedad:</span>
                                  <span class="info-value">{{ lotInfo.VrtName }}</span>
                              </div>
                              <div class="info-row">
                                  <span class="info-label">Tipo Cultivo:</span>
                                  <span class="info-value">{{ lotInfo.TypeCropName }}</span>
                              </div>
                              </div>
                          </div>
                        </v-col>
                        
                        <v-col cols="12" md="5">
                          <div class="info-card">
                              <div class="info-header">
                              <v-icon small class="mr-2">mdi-account-outline</v-icon>
                              <span class="info-title">Productor y Fundo</span>
                              </div>
                              <div class="info-content">
                              <div class="info-row">
                                  <span class="info-label">Productor:</span>
                                  <span class="info-value">{{ lotInfo.PrdCardName }}</span>
                              </div>
                              <div class="info-row">
                                  <span class="info-label">Fundo:</span>
                                  <span class="info-value">{{ lotInfo.FagName }}</span>
                              </div>
                              <div class="info-row">
                                  <span class="info-label">Dirección:</span>
                                  <span class="info-value">{{ lotInfo.FagAddress }}</span>
                              </div>
                              </div>
                          </div>
                        </v-col>

                        <v-col cols="12" md="4">
                          <div class="info-card">
                              <div class="info-header">
                              <v-icon small class="mr-2">mdi-map-outline</v-icon>
                              <span class="info-title">Ubicación</span>
                              </div>
                              <div class="info-content">
                              <div class="info-row">
                                  <span class="info-label">Zona:</span>
                                  <span class="info-value">{{ lotInfo.ZonDescription }}</span>
                              </div>
                              <div class="info-row">
                                  <span class="info-label">Sub Zona:</span>
                                  <span class="info-value">{{ lotInfo.SzoDescription }}</span>
                              </div>
                              </div>
                          </div>
                        </v-col>
                    </v-row>
                    </div>

                    <!-- "Evaluación - Estado de Campo" -->
                    <div class="section-card" v-if="lotInfo.FltID">
                        <div class="section-header">
                            <v-icon class="mr-2 text--secondary">mdi-clipboard-check-outline</v-icon>
                            <h4 class="section-title">Evaluación - Estado de Campo</h4>
                            <v-spacer></v-spacer>
                            <v-btn
                            color="primary"
                            small
                            @click="openApplicationModal()"
                            class="ml-2"
                            >
                            <v-icon small left>mdi-plus</v-icon>
                            Agregar Aplicación
                            </v-btn>
                        </div>
                        
                        <div class="section-content">
                            <!-- Tabla de aplicaciones -->
                            <div v-if="applications.length > 0" class="applications-container">
                            <v-simple-table dense class="applications-table">
                                <thead>
                                <tr>
                                    <th class="text-left" style="width: 40px;">#</th>
                                    <th class="text-left">Producto/Observación</th>
                                    <th class="text-left">Tipo Aplicación</th>
                                    <th class="text-left">Dosis</th>
                                    <th class="text-left">Cantidad</th>
                                    <th class="text-center" style="width: 100px;">Acciones</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(app, index) in applications" :key="index">
                                    <td class="text-caption">{{ index + 1 }}</td>
                                    <td>
                                      <v-chip small color="primary" text-color="white" class="mr-2">
                                        <v-icon small left>mdi-bottle-tonic</v-icon>
                                        Detalles
                                      </v-chip>
                                      <span class="text-caption">{{ app.LsName }}</span>
                                    </td>
                                    <td>
                                      <v-chip small outlined color="info">
                                        {{ app.TypeApplicationName }}
                                      </v-chip>
                                    </td>
                                    <td class="text-caption">{{ Number(app.PpaDose).toFixed(2) }}</td>
                                    <td class="text-caption">{{ Number(app.AmountTotal).toFixed(2) }}</td>
                                    <td class="text-center">
                                    <v-btn
                                        icon
                                        small
                                        color="primary"
                                        @click="editApplication(app, index)"
                                        class="mr-1"
                                    >
                                        <v-icon small>mdi-pencil</v-icon>
                                    </v-btn>
                                    <v-btn
                                        icon
                                        small
                                        color="error"
                                        @click="deleteApplication(index)"
                                    >
                                        <v-icon small>mdi-delete</v-icon>
                                    </v-btn>
                                    </td>
                                </tr>
                                </tbody>
                            </v-simple-table>
                            </div>
                            
                            <!-- Estado vacío -->
                            <div v-else class="empty-state">
                            <div class="empty-content">
                                <v-icon size="64" color="grey lighten-1">mdi-clipboard-outline</v-icon>
                                <h4 class="grey--text text--lighten-1 mt-2">No hay aplicaciones registradas</h4>
                                <p class="grey--text text--lighten-2 text-caption">
                                Agregue aplicaciones de fitosanitarios y fertilizantes
                                </p>
                                <v-btn
                                color="primary"
                                outlined
                                @click="openApplicationModal()"
                                class="mt-2"
                                >
                                <v-icon left>mdi-plus</v-icon>
                                Agregar Primera Aplicación
                                </v-btn>
                            </div>
                            </div>
                        </div>
                    </div>

                    <!-- "Estado Fenológico" -->
                    <v-container fluid v-if="lotInfo.FltID">
                      <v-row>
                        <v-col md="4" cols="12">
                          <div class="section-card">
                            <div class="section-header">
                              <v-icon class="mr-2 text--secondary">mdi-leaf</v-icon>
                              <h4 class="section-title">Estado Fenológico</h4>
                            </div>
                            
                            <div class="section-content">
                              
                              <div class="phenology-stages-grid">
                                <div 
                                  v-for="(stage, index) in phenologyStages" 
                                  :key="index"
                                  class="phenology-stage-item"
                                >
                                  <div class="stage-info">
                                    <span class="stage-name">{{ stage.label }}</span>
                                  </div>
                                  <div class="stage-input">
                                    <s-text
                                      decimal
                                      v-model="phenologyData[stage.value]"
                                      valueDefault="0"
                                      placeholder="0"
                                      outlined
                                      dense
                                      suffix="%"
                                      :rules="[v => validatePercentage(v)]"
                                      @input="value => onPhenologyChange(value, stage.value)"
                                      hide-details
                                    />
                                  </div>
                                </div>
                              </div>
                              
                              <!-- Indicador de total -->
                              <div class="phenology-total-compact mt-3">
                                <div class="total-info">
                                  <span class="total-label">Total: </span>
                                  <span class="total-value" :class="{ 'error': totalPhenologyPercent > 100 }">
                                    {{ totalPhenologyPercent.toFixed(1) }}%
                                  </span>
                                </div>
                                <v-progress-linear
                                  :value="totalPhenologyPercent"
                                  :color="totalPhenologyPercent > 100 ? 'error' : 'success'"
                                  height="4"
                                  class="mt-1"
                                />
                              </div>
                                
                            </div>
                          </div>
                        </v-col>

                        <v-col md="8" cols="12">
                          <v-row>
                            <!-- Bloque 1 -->
                            <v-col cols="12">
                              <!-- Evaluación Fitosanitaria -->
                              <div class="section-card">
                                <div class="section-header">
                                  <v-icon class="mr-2 text--secondary">mdi-clipboard-check-outline</v-icon>
                                  <h4 class="section-title">Evaluación Fitosanitaria</h4>
                                  <v-spacer></v-spacer>
                                  <v-btn
                                    outlined
                                    color="grey darken-1"
                                    small
                                    dark
                                    @click="cancelPhytosanitaryForm"
                                    v-if="editingPhytosanitaryIndex >= 0"
                                    class="mr-1"
                                  >
                                    <v-icon small left>mdi-close</v-icon>
                                    Cancelar
                                  </v-btn>

                                  <v-btn
                                    color="primary"
                                    small
                                    @click="savePhytosanitaryEvaluation"
                                    :disabled="!isValidPhytosanitary"
                                  >
                                    <v-icon small left>{{ editingPhytosanitaryIndex >= 0 ? 'mdi-content-save' : 'mdi-plus' }}</v-icon>
                                    {{ editingPhytosanitaryIndex >= 0 ? 'Actualizar' : 'Agregar' }}
                                  </v-btn>
                                  
                                </div>
                                
                                <div class="section-content">
                                  <!-- Formulario para agregar evaluación -->
                                  <v-card class="mb-4" outlined>
                                    <v-card-text>
                                      <v-container>
                                        <v-row>
                                          <v-col lg="5" class="pt-0 pb-0" cols="6">
                                            <s-select-plagues
                                              :typeCultive="lotInfo.TypeCultive || 0"
                                              clearable
                                              v-model="currentPhytosanitary.PlID"
                                              label="Enfermedad/Plaga/Maleza"
                                              :returnObject="true"
                                            />
                                          </v-col>
                                          <v-col lg="4" class="pt-0 pb-0" cols="6">
                                            <s-select-definition
                                              :def="1208"
                                              add
                                              clearable
                                              v-model="currentPhytosanitary.TypeOrganPlant"
                                              @getDataInitial="getDataTypeOrganPlant($event)"
                                              label="Organo"
                                            />
                                          </v-col>
                                          <v-col lg="3" class="pt-0 right" cols="12">
                                            <s-text
                                              label="Porcentaje"
                                              ref="PhePercentage"
                                              decimal
                                              v-model="currentPhytosanitary.PhePercentage"
                                            />
                                          </v-col>
                                        </v-row>
                                      </v-container>
                                    </v-card-text>
                                  </v-card>

                                  <!-- Reemplaza esta sección en tu template -->
                                  <div v-if="phytosanitaryEvaluations.length > 0" class="evaluations-container">
                                    <v-simple-table dense class="evaluations-table">
                                      <template v-slot:default>
                                        <thead>
                                          <tr>
                                            <th class="text-left" style="width: 40px;">#</th>
                                            <th class="text-left">Enfermedad/Plaga/Maleza</th>
                                            <th class="text-left">Organo</th>
                                            <th class="text-left">Porcentaje</th>
                                            <th class="text-center" style="width: 100px;">Acciones</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr v-for="(evaluation, index) in phytosanitaryEvaluations" :key="index">
                                            <td class="text-caption">{{ index + 1 }}</td>
                                            <td>
                                              <v-icon small left>mdi-bug</v-icon>
                                              <span class="text-caption">{{ evaluation.PlName }}</span>
                                            </td>
                                            <td>
                                              <v-chip x-small outlined color="info">
                                                {{ evaluation.TypeOrganName }}
                                              </v-chip>
                                            </td>
                                            <td class="text-caption">{{ Number(evaluation.PhePercentage).toFixed(1) }}%</td>
                                            <td class="text-center">
                                              <v-btn
                                                icon
                                                small
                                                color="primary"
                                                @click="editPhytosanitaryEvaluation(evaluation, index)"
                                                class="mr-1"
                                              >
                                                <v-icon small>mdi-pencil</v-icon>
                                              </v-btn>
                                              <v-btn
                                                icon
                                                small
                                                color="error"
                                                @click="deletePhytosanitaryEvaluation(index)"
                                              >
                                                <v-icon small>mdi-delete</v-icon>
                                              </v-btn>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </template>
                                    </v-simple-table>
                                  </div>
                                  
                                  <!-- Estado vacío -->
                                  <div v-else class="empty-state">
                                    <div class="empty-content">
                                      <v-icon size="64" color="grey lighten-1">mdi-clipboard-pulse</v-icon>
                                      <h4 class="grey--text text--lighten-1 mt-2">No hay evaluaciones fitosanitarias</h4>
                                      <p class="grey--text text--lighten-2 text-caption">
                                        Agregue evaluaciones de plagas, enfermedades y malezas
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </v-col>

                            <!-- Bloque 2 -->
                            <v-col cols="12">
                              <div class="section-card">
                                <div class="section-header">
                                  <v-icon class="mr-2 text--secondary">mdi-death-star-variant</v-icon>
                                  <h4 class="section-title">Actividades Culturales realizadas</h4>
                                  <v-spacer></v-spacer>
                                  <v-btn
                                    outlined
                                    color="grey darken-1"
                                    small
                                    dark
                                    @click="cancelPerformedActivityForm"
                                    v-if="editingPerformedActivityIndex >= 0"
                                    class="mr-1"
                                  >
                                    <v-icon small left>mdi-close</v-icon>
                                    Cancelar
                                  </v-btn>

                                  <v-btn
                                    color="primary"
                                    small
                                    @click="savePerformedActivity"
                                    :disabled="!isValidPerformedActivity"
                                  >
                                    <v-icon small left>{{ editingPerformedActivityIndex >= 0 ? 'mdi-content-save' : 'mdi-plus' }}</v-icon>
                                    {{ editingPerformedActivityIndex >= 0 ? 'Actualizar' : 'Agregar' }}
                                  </v-btn>
                                </div>
                                
                                <div class="section-content">
                                  <!-- Formulario para agregar evaluación -->
                                  <v-card class="mb-4" outlined>
                                    <v-card-text>
                                      <v-container>
                                        <v-row>
                                          <v-col sm="4" cols="6">
                                            <s-select-definition
                                              :def="1204"
                                              v-model="currentPerformedActivity.objTypeActivity"
                                              add
                                              label="Actividad"
                                              return-object/>
                                          </v-col>
                                          <v-col sm="4" cols="6">
                                            <s-date
                                              label="Fecha Inicio"
                                              v-model="currentPerformedActivity.PacBeginDate" /> 
                                          </v-col>
                                          <v-col sm="4" cols="6">
                                            <s-date 
                                              label="Fecha Fin" 
                                              v-model="currentPerformedActivity.PacEndDate"/> 
                                          </v-col>
                                        </v-row>
                                        <v-row v-if="currentPerformedActivity.objTypeActivity.DedValue == 1">
                                          <v-col sm="4" cols="6">
                                            <s-select-definition
                                              label="Sistema" 
                                              v-model="currentPerformedActivity.TypeIrrigation"
                                              :def="1352">
                                            </s-select-definition>
                                          </v-col>
                                          <v-col sm="4" cols="6">
                                            <s-select-definition
                                              label="Tipo sistema"                                    
                                              v-model="currentPerformedActivity.TypeDetailIrrigation"
                                              :def="1353">
                                            </s-select-definition>
                                          </v-col>
                                          <v-col sm="4" cols="6">
                                            <s-text 
                                              v-model="currentPerformedActivity.PacFuelCost" 
                                              label="Gasto de combustible" 
                                              decimal 
                                              ref="refPacFuelCost"/> 
                                          </v-col>
                                          <v-col sm="4" cols="6">
                                            <s-text 
                                              v-model="currentPerformedActivity.PacFlowIrrigation" 
                                              label="Caudal de riego (L/s)" 
                                              decimal 
                                              ref="refPacFlowIrrigation"/> 
                                          </v-col>
                                          <v-col sm="4" cols="6">
                                            <s-text 
                                              v-model="currentPerformedActivity.PacTimeIrrigation" 
                                              label="Tiempo de riego (H)" 
                                              decimal 
                                              ref="refPacTimeIrrigation"/> 
                                          </v-col>
                                        </v-row>
                                        <v-row v-if="currentPerformedActivity.objTypeActivity.DedValue == 2">
                                          <v-col sm="4" cols="6">
                                            <s-text 
                                              v-model="currentPerformedActivity.PacNumberOfTrees" 
                                              number label="Número de arboles podados" 
                                              ref="refPacNumberOfTrees" /> 
                                          </v-col>
                                        </v-row>
                                        <v-row v-if="currentPerformedActivity.objTypeActivity.DedValue == 3">
                                          <v-col sm="4" cols="6">
                                            <s-select-definition
                                              label="Tipo de deshierbo"
                                              v-model="currentPerformedActivity.TypeWeeding"                                   
                                              :def="1354">
                                            </s-select-definition>
                                          </v-col>
                                          <v-col sm="4" cols="6">
                                            <s-text 
                                              v-if="currentPerformedActivity.TypeWeeding == 3"
                                              v-model="currentPerformedActivity.PacAmountFuelGallons" 
                                              label="Cantidad de combustible (Gal)" 
                                              decimal 
                                              ref="refPacAmountFuelGallons"/> 
                                          </v-col>
                                        </v-row>
                                        <v-row v-if="currentPerformedActivity.objTypeActivity.DedValue == 4">
                                          <v-col sm="4" cols="6">
                                            <s-select-definition
                                              label="Tipo de trampa"                                   
                                              v-model="currentPerformedActivity.TypeTrap"
                                              :def="1355">
                                            </s-select-definition>
                                          </v-col>
                                          <v-col sm="4">
                                            <s-text 
                                              v-model="currentPerformedActivity.PacNumberTrap" 
                                              label="Número de trampas" 
                                              number 
                                              ref="refPacNumberTrap"/> 
                                          </v-col>
                                        </v-row>
                                      </v-container>
                                    </v-card-text>
                                  </v-card>

                                  <!-- Reemplaza esta sección en tu template -->
                                  <div v-if="performedActivities.length > 0" class="evaluations-container">
                                    <v-simple-table dense class="evaluations-table">
                                      <thead>
                                        <tr>
                                          <th class="text-left" style="width: 40px;">#</th>
                                          <th class="text-left">Actividad</th>
                                          <th class="text-left">Fecha Inicio</th>
                                          <th class="text-left">Fecha Fin</th>
                                          <th class="text-center" style="width: 100px;">Acciones</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr v-for="(activity, index) in performedActivities" :key="index">
                                          <td class="text-caption">{{ index + 1 }}</td>
                                          <td>
                                            <v-chip x-small color="primary" text-color="white">
                                              <v-icon x-small left>mdi-{{ getActivityIcon(activity.TypeActivity) }}</v-icon>
                                              {{ activity.TypeActivityName }}
                                            </v-chip>
                                          </td>
                                          <td class="text-caption">{{ $fun.formatDateView(activity.PacBeginDate) }}</td>
                                          <td class="text-caption">{{ $fun.formatDateView(activity.PacEndDate) }}</td>
                                          <td class="text-center">
                                            <v-btn
                                              icon
                                              x-small
                                              color="primary"
                                              @click="editPerformedActivity(activity, index)"
                                              class="mr-1"
                                            >
                                              <v-icon x-small>mdi-pencil</v-icon>
                                            </v-btn>
                                            <v-btn
                                              icon
                                              x-small
                                              color="error"
                                              @click="deletePerformedActivity(index)"
                                            >
                                              <v-icon x-small>mdi-delete</v-icon>
                                            </v-btn>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </v-simple-table>
                                  </div>

                                  <!-- Estado vacío -->
                                  <div v-else class="empty-state">
                                    <div class="empty-content">
                                      <v-icon size="64" color="grey lighten-1">mdi-clipboard-list-outline</v-icon>
                                      <h4 class="grey--text text--lighten-1 mt-2">No hay actividades registradas</h4>
                                      <p class="grey--text text--lighten-2 text-caption">
                                        Agregue actividades culturales realizadas
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </v-col>
                          
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-container>
                    
                    <!-- Evaluación de Instalaciones -->
                    <div class="section-card" v-if="lotInfo.FltID">
                      <div class="section-header">
                        <v-icon class="mr-2 text--secondary">mdi-home-circle-outline</v-icon>
                        <h4 class="section-title">Evaluación de Instalaciones</h4>
                      </div>
                      
                      <div class="section-content">
                        <v-card class="pa-4" flat>
                          <v-row v-if="installationTypes.length > 0">
                            <v-col cols="6" sm="3" md="2" lgs="4" v-for="(item, index) in installationTypes" :key="index">
                              <v-switch
                                :label="item.DedDescription"
                                v-model="item.IneStatus"
                                color="primary"
                                hide-details
                                @change="saveInstallationEvaluation(item)"
                              ></v-switch>
                            </v-col>
                          </v-row>
                          
                          <div v-else class="empty-state">
                            <v-icon size="64" color="grey lighten-1">mdi-home-import-outline</v-icon>
                            <h4 class="grey--text text--lighten-1 mt-2">No hay tipos de instalación configurados</h4>
                          </div>
                        </v-card>
                      </div>
                    </div>

                    <!-- Sección de Recomendaciones -->
                    <div class="section-card" v-if="lotInfo.FltID">
                      <div class="section-header">
                        <v-icon class="mr-2 text--secondary">mdi-comment-quote-outline</v-icon>
                        <h4 class="section-title">Recomendaciones</h4>
                      </div>
                      
                      <div class="section-content">
                        <!-- V-chips para abrir modales -->
                        <div v-if="recomendationAplications && recomendationAplications.length" class="d-flex justify-center flex-wrap mb-4">
                          <v-chip
                            v-for="(item, idx) in recomendationAplications"
                            :key="item.value"
                            class="ma-1"
                            color="primary"
                            outlined
                            @click="openRecomendationModal(item)"
                            style="cursor:pointer"
                            dark
                          >
                            <v-icon left small>mdi-lightbulb-on-outline</v-icon>
                            {{ item.label }}
                            <span class="helper-circle ml-2">{{ item.helper }}</span>
                          </v-chip>
                        </div>
                        <div v-else class="grey--text text--lighten-1 mb-4">
                          No hay recomendaciones configuradas.
                        </div>

                        <!-- Tabla FIJA de todas las recomendaciones -->
                        <div v-if="allRecommendations.length > 0" class="recommendations-table-container">
                          <!-- <v-data-table
                            dense
                            :headers="headersRecommendations"
                            :items="allRecommendations"
                            item-key="id"
                            class="recommendations-table"
                            :mobile-breakpoint="768"
                          >
                            <template v-slot:item.helpers="{ item }">
                              <div class="d-flex flex-wrap">
                                <v-chip
                                  v-for="helper in recomendationAplications"
                                  :key="helper.value"
                                  x-small
                                  class="ma-1"
                                  :color="helper.value === item.typeApplication ? 'primary' : 'grey'"
                                  :outlined="helper.value !== item.typeApplication"
                                  :text-color="helper.value === item.typeApplication ? 'white' : 'grey'"
                                >
                                  {{ helper.helper }}
                                </v-chip>
                              </div>
                            </template>

                            <template v-slot:item.plagueName="{ item }">
                              <v-icon small left class="mr-1">mdi-bug</v-icon>
                              <span class="text-caption">{{ item.plagueName }}</span>
                            </template>

                            <template v-slot:item.typeOrderName="{ item }">
                              <v-chip x-small color="info" text-color="white" v-if="item.typeOrderName">
                                {{ item.typeOrderName }}
                              </v-chip>
                              <span v-else class="text-caption grey--text">Sin orden</span>
                            </template>

                            <template v-slot:item.productName="{ item }">
                              <v-chip x-small outlined color="success">
                                {{ item.productName }}
                              </v-chip>
                            </template>

                            <template v-slot:item.dose="{ item }">
                              <span class="text-caption">{{ Number(item.dose).toFixed(2) }}</span>
                            </template>

                            <template v-slot:item.actions="{ item, index }">
                              <v-btn icon small color="primary" @click="editRecommendation(item, index)" class="mr-1">
                                <v-icon small>mdi-pencil</v-icon>
                              </v-btn>
                              <v-btn icon small color="error" @click="deleteRecommendation(index)">
                                <v-icon small>mdi-delete</v-icon>
                              </v-btn>
                            </template>
                          </v-data-table> -->
                          <v-simple-table dense class="recommendations-table" :mobile-breakpoint="768">
                            <template v-slot:default>
                              <thead>
                                <tr>
                                  <th class="text-left" style="width: 40px;">#</th>
                                  <th class="text-left">Helpers</th>
                                  <th class="text-left">Enfermedad/Plaga/Maleza</th>
                                  <th class="text-left">Producto</th>
                                  <th class="text-left">Dosis</th>
                                  <th class="text-left">Orden</th>
                                  <th class="text-center" style="width: 100px;">Acciones</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="(recommendation, index) in allRecommendations" :key="index">
                                  <td class="text-caption">{{ index + 1 }}</td>
                                  
                                  <!-- Columna de Helpers - muestra todos pero resalta el correspondiente -->
                                  <td>
                                    <div class="d-flex flex-wrap">
                                      <v-chip
                                        v-for="helper in recomendationAplications"
                                        :key="helper.value"
                                        x-small
                                        class="ma-1"
                                        :color="helper.value === recommendation.typeApplication ? 'primary' : 'grey'"
                                        :outlined="helper.value !== recommendation.typeApplication"
                                        :text-color="helper.value === recommendation.typeApplication ? 'white' : 'grey'"
                                      >
                                        {{ helper.helper }}
                                      </v-chip>
                                    </div>
                                  </td>
                                  
                                  <td>
                                    <v-icon small left>mdi-bug</v-icon>
                                    <span class="text-caption">{{ recommendation.plagueName }}</span>
                                  </td>
                                  
                                  <td>
                                    <v-chip x-small outlined color="success">
                                      {{ recommendation.productName }}
                                    </v-chip>
                                  </td>
                                  
                                  <td class="text-caption">{{ Number(recommendation.dose).toFixed(2) }}</td>
                                  
                                  <td>
                                    <v-chip x-small color="info" text-color="white" v-if="recommendation.typeOrderName">
                                      {{ recommendation.typeOrderName }}
                                    </v-chip>
                                    <span v-else class="text-caption grey--text">Sin orden</span>
                                  </td>
                                  
                                  <td class="text-center">
                                    <v-btn
                                      icon
                                      small
                                      color="primary"
                                      @click="editRecommendation(recommendation, index)"
                                      class="mr-1"
                                    >
                                      <v-icon small>mdi-pencil</v-icon>
                                    </v-btn>
                                    <v-btn
                                      icon
                                      small
                                      color="error"
                                      @click="deleteRecommendation(index)"
                                    >
                                      <v-icon small>mdi-delete</v-icon>
                                    </v-btn>
                                  </td>
                                </tr>
                              </tbody>
                            </template>
                          </v-simple-table>
                        </div>
                        <!-- Estado vacío para la tabla -->
                        <div v-else class="empty-state">
                          <div class="empty-content">
                            <v-icon size="64" color="grey lighten-1">mdi-lightbulb-on-outline</v-icon>
                            <h4 class="grey--text text--lighten-1 mt-2">No hay recomendaciones agregadas</h4>
                            <p class="grey--text text--lighten-2 text-caption">
                              Agregue recomendaciones precionando en las opciones de arriba.
                            </p>
                          </div>
                        </div>

                        <div class="mt-4">
                          <s-textarea  
                            v-model="RchNote"
                            label="Recomendacion"/>
                        </div>
                      </div>
                    </div>

                    <!-- Sección de Actividades Culturales -->
                    <div class="section-card" v-if="lotInfo.FltID">
                      <div class="section-header">
                        <v-icon class="mr-2 text--secondary">mdi-sprout-outline</v-icon>
                        <h4 class="section-title">Actividades Culturales</h4>
                      </div>
                      
                      <div class="section-content">
                        <v-row v-if="itemsTypeActivities.length > 0">
                            <v-col cols="6" sm="3" md="2" lgs="4" v-for="(item, index) in itemsTypeActivities" :key="index">
                              <v-switch
                                :label=" item.DedDescription ? item.DedDescription : item.TypeActivityName"
                                v-model="item.AcuStatus"
                                color="primary"
                                hide-details
                              ></v-switch>
                            </v-col>
                          </v-row>
                      </div>
                    </div>

                    <div class="section-card" v-if="lotInfo.FltID">

                      <div class="section-header">
                        <v-icon class="mr-2 text--secondary">mdi-timeline-text-outline</v-icon>
                        <h4 class="section-title">Observaciones</h4>
                        <v-spacer></v-spacer>
                        <!-- <v-btn
                          outlined
                          color="grey darken-1"
                          small
                          dark
                          @click="cancelObservationRecord"
                          v-if="editIndex >= 0"
                          class="mr-1"
                        >
                          <v-icon small left>mdi-close</v-icon>
                          Cancelar
                        </v-btn> -->
                        <v-btn 
                          small
                          color="primary" 
                          @click="addObservation" 
                          :disabled="!RobObs || RobObs.length < 3"
                        >
                          <v-icon left>mdi-plus</v-icon>
                          Agregar
                        </v-btn>
                      </div>
                      
                      <div class="section-content">
                        <!-- Textarea y botón para agregar observación -->
                        <v-row class="align-center">
                          <v-col cols="12" md="12">
                            <s-textarea
                              v-model="RobObs"
                              label="Observación"
                              
                            />
                          </v-col>
                        </v-row>


                        <!-- Tabla de observaciones -->
                        <div v-if="observations.length > 0" class="mt-4">
                          <v-data-table
                            :headers="headersObs"
                            :items="observations.filter(o => o.SecStatus == 1)"
                            class="mt-4"
                            dense
                            item-key="id"
                          >
                            <template v-slot:item.RobObs="{ item }">
                              <span>{{ item.RobObs }}</span>
                            </template>
                            <template v-slot:item.actions="{ item, index }">
                              <v-btn icon small color="primary" @click="editObservation(item, index)">
                                <v-icon small>mdi-pencil</v-icon>
                              </v-btn>
                              <v-btn icon small color="error" @click="deleteObservation(index)">
                                <v-icon small>mdi-delete</v-icon>
                              </v-btn>
                            </template>
                          </v-data-table>
                        </div>

                        <div v-else class="empty-state mt-4">
                          <div class="empty-content">
                            <v-icon size="64" color="grey lighten-1">mdi-comment-text-outline</v-icon>
                            <h4 class="grey--text text--lighten-1 mt-2">No hay observaciones agregadas</h4>
                            <p class="grey--text text--lighten-2 text-caption">
                              Agregue observaciones presionando el botón "Agregar".
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Configuraciones y Observaciones - Optimizado -->
                    <div class="section-card">
                    <div class="section-header">
                        <v-icon class="mr-2 text--secondary">mdi-cog-outline</v-icon>
                        <h4 class="section-title">Configuraciones y Observaciones</h4>
                    </div>
                    <v-row class="section-content">
                        <v-col cols="12" md="6">
                        <div class="switch-container">
                            <s-switch
                            label="Firma del Productor"
                            v-model="formData.PrdSignature"
                            class="custom-switch"
                            />
                            <small class="text--secondary">
                            Requerida para validar la visita
                            </small>
                        </div>
                        </v-col>
                        <v-col cols="12" md="6">
                        <s-textarea
                            label="Observaciones"
                            v-model="formData.VstObservation"
                            :rows="3"
                            outlined
                            dense
                            placeholder="Ingrese observaciones adicionales..."
                        />
                        </v-col>
                    </v-row>
                    </div>

                    <!-- Alerta de última visita -->
                    <v-alert
                    v-if="messageFarmLot"
                    type="info"
                    class="mx-4 mb-4"
                    border="left"
                    colored-border
                    elevation="1"
                    >
                    <div class="d-flex align-center">
                        <v-icon class="mr-2">mdi-information</v-icon>
                        <span>{{ messageFarmLot }}</span>
                    </div>
                    </v-alert>

                </div>
                </v-form>
            </v-card-text>

            <!-- Footer mejorado -->
            <v-card-actions class="footer-actions pa-4">
                <v-spacer></v-spacer>
                <v-btn
                outlined
                color="grey darken-1"
                @click="closeModal"
                class="mr-2"
                >
                <v-icon left>mdi-close</v-icon>
                Cancelar
                </v-btn>
                <v-btn
                color="primary"
                @click="saveVisit"
                :disabled="!valid || !lotInfo.FltID"
                :loading="saving"
                elevation="2"
                >
                <v-icon left>{{ isEdit ? 'mdi-content-save' : 'mdi-plus' }}</v-icon>
                {{ isEdit ? 'Actualizar' : 'Guardar' }}
                </v-btn>
            </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Modal SIMPLE solo con formulario -->
        <v-dialog
          v-model="recomendationModalOpen"
          persistent
          max-width="800px"
        >
          <v-card class="modern-modal">
            <!-- Header -->
            <v-card-title class="header-gradient white--text pa-4 elevation-2">
              <div class="d-flex align-center">
                <v-icon class="mr-3" large dark>mdi-lightbulb-on-outline</v-icon>
                <div>
                  <h3 class="mb-0">{{ editingRecommendationIndex >= 0 ? 'Editar' : 'Agregar' }} Recomendación</h3>
                  <p class="mb-0 text-caption opacity-80">
                    {{ selectedRecomendation ? selectedRecomendation.label : '' }}
                  </p>
                </div>
              </div>
              <v-spacer></v-spacer>
              <v-btn icon dark @click="closeRecomendationModal" class="ml-2">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>

            <v-card-text class="pa-4">
              <v-form ref="recommendationForm" v-model="validRecommendation">
                <v-row>
                  <v-col sm="6" cols="12">
                    <s-select-plagues
                      return-object
                      clearable
                      :typeCultive="lotInfo.TypeCultive || 0"
                      label="Enfermedad/Plaga/Maleza*"
                      v-model="currentRecommendation.plague"
                      :rules="[v => !!v || 'Este campo es requerido']"
                      @input="inputPlague($event)"
                    />
                  </v-col>
                  
                  <v-col sm="6" cols="12">
                    <s-select-listsupplies
                      full
                      label="Producto*"
                      return-object 
                      v-model="currentRecommendation.product"
                      :rules="[v => !!v || 'Este campo es requerido']"
                      @input="inputProductRecomendation($event)"
                    />
                  </v-col>
                  
                  <v-col sm="6" cols="12">
                    <s-text
                      decimal
                      label="Dosis*"
                      ref="DoceRecomendation"
                      v-model="currentRecommendation.dose"
                      :rules="[
                        v => !!v || 'Este campo es requerido',
                        v => v > 0 || 'La dosis debe ser mayor a 0'
                      ]"
                    />
                  </v-col>
                  
                  <v-col sm="6" cols="12">
                    <s-select-definition
                      label="Orden"
                      :def="1441"
                      v-model="currentRecommendation.typeOrder"
                      return-object
                      @input="inputTypeOrder($event)"
                      add
                    />
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <!-- Footer del modal -->
            <v-card-actions class="pa-4 border-top">
              <v-spacer></v-spacer>
              <v-btn
                outlined
                color="grey darken-1"
                @click="closeRecomendationModal"
                class="mr-2"
              >
                <v-icon left>mdi-close</v-icon>
                Cancelar
              </v-btn>
              <v-btn
                color="primary"
                @click="saveRecommendation"
                :disabled="!validRecommendation"
              >
                <v-icon left>{{ editingRecommendationIndex >= 0 ? 'mdi-content-save' : 'mdi-plus' }}</v-icon>
                {{ editingRecommendationIndex >= 0 ? 'Actualizar' : 'Guardar' }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <ApplicationModal
            v-model="applicationModalOpen"
            :application-data="selectedApplication"
            :is-edit="isEditingApplication"
            :type-cultive="lotInfo.TypeCultive || 0"
            @saved="onApplicationSaved"
            @close="onApplicationModalClose"
        />

        <FarmLoader :visible="saving" />
    </div>
</template>

<script>
import SSelectSupervice from "@/components/HarvestSchedule/SSelectSupervice";
import SSearchLotByCodSenasa from "@/components/HarvestSchedule/sSearchLotByCodSenasa.vue";
import SSelectCampaignArea from "@/components/Utils/SSelectCampaignArea.vue";
import _sServices from "@/services/Technicalassistance/Visit/Visit.js";
import ApplicationModal from './ApplicationModal.vue';
import _sDefinition from "@/services/General/DefinitionService.js";
import SSelectPlagues from "@/components/TecnicalAssistence/Plagues/SSelectPlagues";
import sSelectListsupplies from "@/components/TecnicalAssistence/ListSupplies/SSelectListsupplies";
import _visitApplication from "@/services/Technicalassistance/Visit/VisitApplicationsService.js";
import _visitPhenology from "@/services/Technicalassistance/Visit/VisitPhenologicalService.js";
import _visitPhytosanitary from "@/services/Technicalassistance/Visit/VisitPhytosanitaryEvaluationService";
import _visitPerformedActivity from "@/services/Technicalassistance/Visit/VisitPerformedActivitiesService";
import _visitInstallationEvaluations from "@/services/Technicalassistance/Visit/VisitInstallationEvaluationService";
import _visitRecommendations from "@/services/Technicalassistance/Visit/VisitRecomendationHeadService.js";
import _visitTypeActivities from "@/services/Technicalassistance/Visit/VisitActivityCulturalService";
import _visitObservations from "@/services/Technicalassistance/Visit/VisitRecomendationObsService.js";
import FarmLoader from './loader.vue'
import { v4 as uuidv4 } from 'uuid';

export default {
  name: "VisitFormModal",
  components: {
    SSelectSupervice,
    SSearchLotByCodSenasa,
    SSelectCampaignArea,
    ApplicationModal,
    SSelectPlagues,
    sSelectListsupplies,
    FarmLoader
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    visitData: {
      type: Object,
      default: () => ({})
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    PlID: {
      type: Number,
      default: 0
    },
    preloadData: {
      type: Object,
      default: () => ({})
    },
    VisitID : {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      valid: false,
      saving: false,
      messageFarmLot: "",
      formData: {
        VstID: null,
        VstDate: null,
        VstSerie: "",
        VstNumber: "",
        TvID: null,
        VstSupervisorPrsID: null,
        GenID: null,
        PrdSignature: 0,
        VstObservation: "",
        FltID: null,
        ZonID: null,
        SzoID: null,
        CmaID: null,
        PlID: this.PlID
      },
      lotInfo: {
        FltID: null,
        FltName: "",
        VrtName: "",
        PrdCardName: "",
        FagName: "",
        FagAddress: "",
        ZonDescription: "",
        SzoDescription: "",
        TypeCropName: "",
        TypeCultive: null,
        ZonID: null,
        SzoID: null
      },
      applications: [],
      deletedApplications: [],
      applicationModalOpen: false,
      selectedApplication: {},
      isEditingApplication: false,
      editingApplicationIndex: -1,
      phenologyStages: [],
      recomendationAplications: [],
      phenologyData: {},
      totalPhenologyPercent: 0,
      phytosanitaryEvaluations: [],
      deletedPhytosanitaryEvaluations: [],
      showPhytosanitaryForm: false,
      editingPhytosanitaryIndex: -1,
      currentPhytosanitary: {
        PlID: null,
        TypeOrganPlant: null,
        PhePercentage: 0,
        PlName: '',
        TypeOrganName: ''
      },
      itemsTypeOrganPlant: [],
      editingPerformedActivityIndex: -1,
      performedActivities: [],
      currentPerformedActivity: {
        objTypeActivity: {},
        TypeActivity: null,
        PacBeginDate: null,
        PacEndDate: null
      },
      installationEvaluations: [], // Para guardar los switches
      installationTypes: [], // Tipos de instalación (definición 1209)
      loadingInstallations: false,
      recomendationModalOpen: false,
      selectedRecomendation: null,
      editingRecommendationIndex: -1,
      validRecommendation: false,
      currentRecommendation: {
        plague: null,
        product: null,
        dose: null,
        typeOrder: null,
        plagueName: '',
        productName: '',
        typeApplication: null,
        typeApplicationName: ''
      },
      allRecommendations: [], // Todas las recomendaciones (se muestran en la tabla fija)
      deletedRecommendations: [],
      headersRecommendations: [
        { text: 'Tipo de Aplicación', value: 'helpers' },
        { text: 'Plaga/Enfermedad/Maleza', value: 'plagueName' },
        { text: 'Orden', value: 'typeOrderName' },
        { text: 'Producto/Ingrediente activo / Formulación', value: 'productName' },
        { text: 'Dosis', value: 'dose' },
        { text: 'Acciones', value: 'actions', align: 'center', width: 100 },
      ],
      itemsTypeActivities: [],
      RobObs: "",
      observations: [],
      editIndex: null,
      headersObs: [
        { text: 'Observación', value: 'RobObs' },
        { text: 'Acciones', value: 'actions', sortable: false }
      ],
      deletedApplications: [],
      deletedPhytosanitaryEvaluations: [],
      deletedPerformedActivities: [], // Agregar esta si no existe
      deletedRecommendations: [],
      
      // Estados de carga (opcional, para mostrar spinners)
      loadingEdit: false,
      totalItems: 0,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: []
      },
      filter: {
        searchText: '',
      },
      phenologyIDs : {},
      phenologyUUIDs:{},
      RchNote: '',
      RchID: null,
      RchUUID:null,
      location: {
        latitude: null,
        longitude: null
      },
      locationError: null,
      loadingLocation: false,
      watchId: null,
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    },
    isValidPhytosanitary() {
      return this.currentPhytosanitary.PlID && 
            this.currentPhytosanitary.TypeOrganPlant &&
            this.currentPhytosanitary.PhePercentage >= 0 && 
            this.currentPhytosanitary.PhePercentage <= 100;
    },
    isValidPerformedActivity() {
      return this.currentPerformedActivity.objTypeActivity.DedValue && 
            this.currentPerformedActivity.PacBeginDate && 
            this.currentPerformedActivity.PacEndDate;
    }
  },
  watch: {
    dialogVisible(newVal) {
      if (newVal && !this.isEdit) {
        this.$nextTick(() => {
          console.log("🔄 dialogVisible cambió a:", newVal);
          this.location = {};
          this.getCurrentLocation();
        });
      }
      else {
        this.location = {};
      }
    },
    value(newVal) {
      if (newVal) {
        this.initializeForm();
      }
    },
    visitData: {
      handler(newVal) {
        if (newVal && Object.keys(newVal).length > 0 && !this.isEdit) {
          console.log("🔄 visitData cambió:", newVal);
          this.loadVisitData(newVal);
        }
      },
      deep: true,
      immediate: true
    },
    preloadData: {
      handler(newVal) {
        if (newVal && Object.keys(newVal).length > 0 && !this.isEdit) {
          console.log("🔄 preloadData cambió:", newVal);
          this.applyPreloadData(newVal);
        }
      },
      deep: true,
      immediate: true
    },
    isEdit: {
      handler(newVal) {
        console.log("🔄 isEdit cambió a:", newVal);
        // Si cambia el modo de edición y hay datos, recargar
        if (this.visitData && Object.keys(this.visitData).length > 0) {
          this.loadVisitData(this.visitData);
        }
      }
    }
  },
  methods: {
    async applyPreloadData(preloadData) {
      console.log("=== APLICANDO DATOS PRECARGADOS ===");
      console.log("Datos recibidos:", preloadData);

      try {
        // 1. Aplicar supervisor si viene
        if (preloadData.TvSupervisorPrsID) {
          this.formData.VstSupervisorPrsID = preloadData.TvSupervisorPrsID;
          console.log("✅ Supervisor precargado:", preloadData.TvSupervisorPrsID);
        }

        // 2. Aplicar ID de programación si viene
        if (preloadData.TvID) {
          this.formData.TvID = preloadData.TvID;
          console.log("✅ ID de programación precargado:", preloadData.TvID);
        }


        // 4. Buscar automáticamente por código SENASA si viene
        if (preloadData.FltID) {
          console.log("🔍 Buscando automáticamente código SENASA:", preloadData.FltID);
          //console.log("this.$refs.searchLotSenasa", this.$refs.searchLotSenasa);
          this.$nextTick(() => {
            if (this.$refs.searchLotSenasa) {
              console.log("this.$refs.searchLotSenasa", this.$refs.searchLotSenasa);
              this.$refs.searchLotSenasa.triggerSearch(preloadData.FltID);
            }
          });
        }

        console.log("✅ DATOS PRECARGADOS APLICADOS CORRECTAMENTE");

      } catch (error) {
        console.error("❌ Error al aplicar datos precargados:", error);
        this.$fun.alert(`Error al precargar datos: ${error.message}`, "error");
      }
    },
    async saveVisit() {
      console.log("=== GUARDANDO VISITA ===");
      if (!this.validateForm()) {
        return;
      }
      console.log("✅ FORMULARIO VALIDADO");

      const r = await this.$fun.alertFull("¿Seguro de guardar?", "question");
      if (!r.value) {
        console.log("❌ Aprobación cancelada por el usuario");
        return;
      }
  
      this.saving = true;
      
      try {
        console.log("=== INICIO DEL PROCESO DE GUARDADO ===");
        
        // 1. GUARDAR CABECERA (Información del Documento + Información del Lote)
        const headerData = await this.saveHeader();

        if (!headerData || !headerData.VstID) {
          throw new Error("No se pudo guardar la cabecera de la visita");
        }
        
        console.log("✅ CABECERA GUARDADA:", headerData);
        
        // Actualizar el ID de la visita para las siguientes operaciones
        this.formData.VstID = headerData.VstID;
        
        // 2. GUARDAR APLICACIONES (Evaluación - Estado de Campo)
        if (this.applications.length > 0 || this.deletedApplications.length > 0) {
          const applicationsResult = await this.saveApplications(headerData.VstID);
          console.log("✅ APLICACIONES GUARDADAS:", applicationsResult);
        } else {
          console.log("⚠️ No hay aplicaciones para guardar");
        }
        
        // 3. GUARDAR ESTADO FENOLÓGICO
        if (this.totalPhenologyPercent > 0) {
          const phenologyResult = await this.savePhenologyData(headerData.VstID);
          console.log("✅ ESTADO FENOLÓGICO GUARDADO:", phenologyResult);
        } else {
          console.log("⚠️ No hay datos fenológicos para guardar");
        }
        
        // 4. GUARDAR EVALUACIÓN FITOSANITARIA
        if (this.phytosanitaryEvaluations.length > 0 || this.deletedPhytosanitaryEvaluations.length > 0) {
          const phytosanitaryResult = await this.savePhytosanitaryEvaluations(headerData.VstID);
          console.log("✅ EVALUACIÓN FITOSANITARIA GUARDADA:", phytosanitaryResult);
        } else {
          console.log("⚠️ No hay evaluaciones fitosanitarias para guardar");
        }

        // 5. GUARDAR ACTIVIDADES CULTURALES
        if (this.performedActivities.length > 0 || this.deletedPerformedActivities.length > 0) {
          const activitiesResult = await this.savePerformedActivities(headerData.VstID);
          console.log("✅ ACTIVIDADES CULTURALES GUARDADAS:", activitiesResult);
        }

        // 6. GUARDAR EVALUACIÓN DE INSTALACIONES (si hay VstID)
        if (this.formData.VstID && this.installationTypes.length > 0) {
          const installationsResult = await this.saveInstallationEvaluations(headerData.VstID);
          console.log("✅ EVALUACIÓN DE INSTALACIONES:", installationsResult);
        }

        // 7. GUARDAR RECOMENDACIONES
        if (this.allRecommendations.length > 0 || this.deletedRecommendations.length > 0) {
          const recommendationsResult = await this.saveRecommendationsToServer(headerData.VstID);
          console.log("✅ RECOMENDACIONES GUARDADAS:", recommendationsResult);
        } else {
          console.log("⚠️ No hay recomendaciones para guardar");
        }
        
        // 7. GUARDAR ACTIVIDADES CULTURALES
        if (this.itemsTypeActivities.length > 0) {
          const activitiesCulturalResult = await this.saveItemsTypeActivities(headerData.VstID);
          console.log("✅ ACTIVIDADES CULTURALES GUARDADAS:", activitiesCulturalResult);
        } else {
          console.log("⚠️ No hay actividades culturales para guardar");
        }

        if (this.observations.length > 0) {
          const observationsResult = await this.saveObservations(headerData.VstID);
          console.log("✅ OBSERVACIONES GUARDADAS:", observationsResult);
        } else {
          console.log("⚠️ No hay observaciones para guardar");
        }

        console.log("=== PROCESO DE GUARDADO COMPLETADO ===");
        
        this.$fun.alert(
          this.isEdit ? "Visita actualizada correctamente" : "Visita guardada correctamente",
          "success"
        );
        
        this.closeModalSave();
        
      } catch (error) {
        console.error("❌ ERROR EN EL PROCESO DE GUARDADO:", error);
        this.$fun.alert(`Error al guardar la visita: ${error.message}`, "error");
      } finally {
        this.saving = false;
      }
    },

    // MÉTODO 1: Guardar cabecera (Información del Documento + Información del Lote)
    async saveHeader() {
      console.log("--- GUARDANDO CABECERA ---");
      
      const headerData = {
        VstID: this.formData.VstID,
        VstDate: this.formData.VstDate,
        VstSerie: this.formData.VstSerie,
        VstNumber: this.formData.VstNumber,
        TvID: this.formData.TvID,
        VstSupervisorPrsID: this.formData.VstSupervisorPrsID,
        GenID: this.formData.GenID,
        PrdSignature: this.formData.PrdSignature || 0,
        VstObservation: this.formData.VstObservation,
        FltID: this.lotInfo.FltID,
        ZonID: this.lotInfo.ZonID,
        SzoID: this.lotInfo.SzoID,
        CmaID: this.formData.GenID,
        PlID: this.formData.PlID,
        VstLatitude: this.location.latitude,
        VstLongitude: this.location.longitude,
        UsrCreateID: this.$fun.getUserID(),
        SecStatus: 1
      };
      
      console.log("Datos de cabecera a guardar:", headerData);
      
      // LLAMADA REAL AL SERVICIO - Descomenta y ajusta según tu servicio

      const response = await _sServices.save(headerData, this.$fun.getUserID());
      console.log("Respuesta del servicio de guardado:", response.data);
      console.log("Respuesta del servicio de stats:", response.status);
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error("Error al guardar la cabecera");
      }
      
      // SIMULACIÓN TEMPORAL - Elimina esto cuando implementes la llamada real
      // const simulatedResponse = {
      //   status: 200,
      //   data: {
      //     VstID: 12345,
      //     // ...headerData,
      //     // message: "Cabecera guardada correctamente"
      //   }
      // };
      
      // return simulatedResponse.data;
    },

    // MÉTODO 2: Guardar aplicaciones
    async saveApplications() {
      console.log("--- GUARDANDO APLICACIONES ---");

      const userID = this.$fun.getUserID();

      try {
        // Procesar aplicaciones nuevas o actualizadas, una por una
        for (const app of this.applications) {
          app.VstID = this.formData.VstID;
          await _visitApplication.save(app, userID);
          console.log("Aplicación guardada:", app);
        }

        // Procesar aplicaciones eliminadas, una por una
        for (const delApp of this.deletedApplications) {
          delApp.VstID = this.formData.VstID;
          await _visitApplication.save(delApp, userID);
          console.log("Aplicación eliminada:", delApp);
        }

        // Si todo fue bien
        return {
          message: "Éxito",
          savedApplications: this.applications.length,
          deletedApplications: this.deletedApplications.length
        };
      } catch (error) {
        console.error("Error durante el guardado/eliminación:", error);
        throw error;
      }

      // SIMULACIÓN TEMPORAL - Elimina esto cuando implementes la llamada real
      // const simulatedResponse = {
      //   status: 200,
      //   data: {
      //     message: "Aplicaciones guardadas correctamente",
      //     savedApplications: this.applications.length,
      //     deletedApplications: this.deletedApplications.length
      //   }
      // }
      
      // return simulatedResponse.data;
    },

    // MÉTODO 3: Guardar estado fenológico
    async savePhenologyData(vstID) {
      console.log("--- GUARDANDO ESTADO FENOLÓGICO ---");

      const userID = this.$fun.getUserID();
      console.log("Datos de fenología:", this.phenologyData);
      // Construir el array con datos válidos (> 0)
      const phenologyArray = Object.entries(this.phenologyData)
      .filter(([stageValue, value]) =>
        value > 0 || this.phenologyIDs[stageValue] > 0 // ✅ incluir los que ya existen aunque estén en 0
      )
      .map(([stageValue, percentage], index) => {
        return {
          StpID: this.phenologyIDs[stageValue] || 0, // ✅ usar ID si existe, 0 si es nuevo
          VstID: vstID,
          TypeStatePhenological: stageValue,
          StpPercentage: parseFloat(percentage),
          Line: index + 1,
          UsrCreateID: userID,
          SecStatus: 1,
          UUID: this.phenologyIDs[stageValue]? this.phenologyUUIDs?.[stageValue] : uuidv4()
        };
      });

      // Si no hay datos válidos, no guardar nada
      if (phenologyArray.length === 0) {
        console.log("No hay datos fenológicos válidos para guardar.");
        return {
          message: "No se encontraron datos fenológicos para guardar.",
          savedPhenologyCount: 0
        };
      }

      try {
        // Guardar cada registro individualmente
        for (const item of phenologyArray) {
          await _visitPhenology.save(item, userID); // Asegúrate que el método pueda manejar estos datos
          console.log("Estado fenológico guardado:", item);
        }

        // Si todo fue bien
        return {
          message: "Estados fenológicos guardados exitosamente.",
          savedPhenologyCount: phenologyArray.length
        };
      } catch (error) {
        console.error("Error durante el guardado de datos fenológicos:", error);
        throw error;
      }

      // SIMULACIÓN TEMPORAL - Elimina esto cuando implementes la llamada real
      // const simulatedResponse = {
      //   status: 200,
      //   data: {
      //     message: "Estados fenológicos guardados correctamente",
      //     savedPhenologyCount: phenologyArray.length
      //   }
      // }
      
      // return simulatedResponse.data;
    },

    // MÉTODO 4: Guardar evaluación fitosanitaria
    async savePhytosanitaryEvaluations(vstID) {
      console.log("--- GUARDANDO EVALUACIÓN FITOSANITARIA ---");

      const userID = this.$fun.getUserID();
      console.log("this.phytosanitaryEvaluations", this.phytosanitaryEvaluations);
      // Preparar datos a guardar
      const evaluations = this.phytosanitaryEvaluations.map((evaluation, index) => ({
        ...evaluation,
        PlID: typeof evaluation.PlID === 'object' && evaluation.PlID !== null
          ? evaluation.PlID.PlID || 0
          : evaluation.PlID || 0,
        VstID: vstID,
        PheID: evaluation.PheID || 0,
        UsrCreateID: userID,
        SecStatus: 1,
        Line: index + 1,
        UUID:evaluation.UUID || null,
      }));

      // Preparar datos a eliminar
      const deletedEvaluations = this.deletedPhytosanitaryEvaluations.map((evaluation, index) => ({
        ...evaluation,
        PlID: evaluation.PlID?.PlID || 0,
        VstID: vstID,
        SecStatus: 0,
        Line: index + 1
      }));

      console.log("Evaluaciones a guardar:", evaluations);
      console.log("Evaluaciones a eliminar:", deletedEvaluations);

      try {
        // Guardar evaluaciones una por una
        for (const evalItem of evaluations) {
          await _visitPhytosanitary.save(evalItem, userID);
          console.log("Evaluación guardada:", evalItem);
        }

        // Guardar eliminaciones una por una
        for (const delItem of deletedEvaluations) {
          await _visitPhytosanitary.save(delItem, userID);
          console.log("Evaluación eliminada:", delItem);
        }

        // Todo salió bien
        return {
          message: "Evaluaciones fitosanitarias procesadas correctamente.",
          savedEvaluations: evaluations.length,
          deletedEvaluations: deletedEvaluations.length
        };
      } catch (error) {
        console.error("Error durante el guardado/eliminación de evaluaciones fitosanitarias:", error);
        throw error;
      }

      // SIMULACIÓN TEMPORAL - Elimina esto cuando implementes la llamada real
      // const simulatedResponse = {
      //   status: 200,
      //   data: {
      //     message: "Evaluaciones fitosanitarias guardadas correctamente",
      //     savedEvaluations: evaluations.length,
      //     deletedEvaluations: deletedEvaluations.length
      //   }
      // }
      
      // return simulatedResponse.data;
    },

    async savePerformedActivities(vstID) {
      console.log("--- GUARDANDO ACTIVIDADES REALIZADAS ---");

      const userID = this.$fun.getUserID();

      // Asegurarse de que sean arrays
      const activitiesList = Array.isArray(this.performedActivities) ? this.performedActivities : [];
      const deletedList = Array.isArray(this.deletedPerformedActivities) ? this.deletedPerformedActivities : [];

      const activities = activitiesList.map((act, index) => ({
        ...act,
        VstID: vstID,
        UsrCreateID: userID,
        SecStatus: 1,
        Line: index + 1
      }));

      const deletedActivities = deletedList.map((act, index) => ({
        ...act,
        VstID: vstID,
        SecStatus: 0,
        Line: index + 1
      }));

      try {
        for (const activity of activities) {
          await _visitPerformedActivity.save(activity, userID);
          console.log("Actividad guardada:", activity);
        }

        for (const delActivity of deletedActivities) {
          await _visitPerformedActivity.save(delActivity, userID);
          console.log("Actividad eliminada:", delActivity);
        }

        return {
          message: "Actividades procesadas correctamente.",
          savedActivities: activities.length,
          deletedActivities: deletedActivities.length
        };
      } catch (error) {
        console.error("Error al guardar/eliminar actividades:", error);
        throw error;
      }

      // SIMULACIÓN TEMPORAL - Elimina esto cuando implementes la llamada real
      // const simulatedResponse = {
      //   status: 200,
      //   data: {
      //     message: "Actividades guardadas correctamente",
      //     savedActivities: activities.length,
      //     deletedActivities: deletedActivities.length
      //   }
      // }
      
      // return simulatedResponse.data;
    },

    async saveInstallationEvaluations(vstID) {
      console.log("--- GUARDANDO EVALUACIONES DE INSTALACIÓN ---");

      const userID = this.$fun.getUserID();
      console.log("datos de instalaciones", this.installationTypes);
      // Construir arreglo con evaluaciones a guardar (solo las marcadas con IneStatus)
      const evaluationsToSave = (this.installationTypes || [])
      .filter(item => item.IneStatus || item.IneID > 0) // ✅ incluir los que ya existen aunque estén desmarcados
      .map((item, index) => ({
        VstID: vstID,
        TypeInstallation: item.DedValue,
        IneStatus: item.IneStatus ? 1 : 0, // ✅ marcar como activo o inactivo
        IneID: item.IneID || 0,
        UsrCreateID: userID,
        SecStatus: 1,
        Line: index + 1,
        UUID: item.IneID?item.UUID:uuidv4()
      }));

      if (evaluationsToSave.length === 0) {
        console.log("No hay evaluaciones de instalación para guardar.");
        return {
          message: "No se encontraron evaluaciones para guardar.",
          saved: 0
        };
      }

      try {
        for (const evalItem of evaluationsToSave) {
          await _visitInstallationEvaluations.save(evalItem, userID);
          console.log("Evaluación de instalación guardada:", evalItem);
        }

        return {
          message: "Evaluaciones de instalación guardadas correctamente.",
          saved: evaluationsToSave.length
        };
      } catch (error) {
        console.error("Error al guardar evaluaciones de instalación:", error);
        throw error;
      }

      // SIMULACIÓN TEMPORAL - Elimina esto cuando implementes la llamada real
      // const simulatedResponse = {
      //   status: 200,
      //   data: {
      //     message: "Evaluaciones de instalación guardadas correctamente",
      //     saved: evaluationsToSave.length
      //   }
      // }
      
      // return simulatedResponse.data;
    },

    async saveRecommendationsToServer(vstID) {
      if (this.allRecommendations.length === 0 && this.deletedRecommendations.length === 0) {
        return { message: "No hay recomendaciones para guardar" };
      }

      console.log("--- GUARDANDO RECOMENDACIONES ---");
      
      const userID = this.$fun.getUserID();

      const activeRecs = this.allRecommendations.map((rec, index) => ({
        VstID: vstID,
        RcmID: rec.RcmID || 0,
        PlID: rec.plague ? rec.plague.PlID : null,
        LsID: rec.product ? rec.product.LsID : null,
        TypeApplication: rec.typeApplication,
        RcmDose: rec.dose,
        TypeOrder: rec.typeOrder?.DedValue || null,
        Line: index + 1,
        UsrCreateID: userID,
        UsrUpdateID: userID,
        SecStatus: 1,
        UUID: rec.UUID 
      }));

      const deletedRecs = this.deletedRecommendations.map((rec, index) => ({
        VstID: vstID,
        RcmID: rec.RcmID || 0,
        PlID: rec.plague ? rec.plague.PlID : null,
        LsID: rec.product ? rec.product.LsID : null,
        TypeApplication: rec.typeApplication,
        RcmDose: rec.dose,
        TypeOrder: rec.typeOrder?.DedValue || null,
        Line: activeRecs.length + index + 1, // continuar numeración
        UsrCreateID: userID,
        UsrUpdateID: userID,
        SecStatus: 0
      }));

      const recommendationsData = {
        VstID: vstID,
        UsrCreateID: userID,
        UsrUpdateID: userID,
        SecStatus: 1,
        RchNote: this.RchNote,
        RchID: this.RchID,
        UUID: this.RchID ? this.RchUUID : uuidv4(),
        TasVisitRecomendations: [...activeRecs, ...deletedRecs] // 👈 todo junto en un solo arreglo
      };

      console.log("Datos de recomendaciones a guardar:", recommendationsData);

      // Llamada real al servicio
      const response = await _visitRecommendations.save(recommendationsData, userID);

      // Simulación temporal - Elimina esto cuando implementes la llamada real
      // const response = {
      //   status: 200,
      //   data: {
      //     message: "Recomendaciones guardadas correctamente",
      //     savedCount: activeRecs.length,
      //     deletedCount: deletedRecs.length
      //   }
      // }

      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error("Error al guardar las recomendaciones");
      }
    },

    async saveItemsTypeActivities(vstID) {
      console.log("--- GUARDANDO ACTIVIDADES CULTURALES ---");

      const userID = this.$fun.getUserID();

      // Filtrar y mapear las actividades a guardar
      const TypeActivitysToSave = (this.itemsTypeActivities || [])
        .filter(item => item.AcuStatus || item.AcuID > 0) // ✅ incluir las desmarcadas si ya existen
        .map((item, index) => ({
          VstID: vstID,
          TypeActivity: item.DedValue,
          AcuStatus: item.AcuStatus ? 1 : 0, // ✅ enviar el estado real
          AcuObservation: "",
          AcuID: item.AcuID || 0,
          UsrCreateID: userID,
          SecStatus: 1,
          Line: index + 1,
          UUID : item.AcuID? item.UUID :uuidv4()
        }));

      if (TypeActivitysToSave.length === 0) {
        return {
          message: "No hay actividades culturales para guardar.",
          saved: 0
        };
      }

      try {
        for (const activity of TypeActivitysToSave) {
          await _visitTypeActivities.save(activity, userID);
          console.log("Actividad cultural guardada:", activity);
        }

        return {
          message: "Actividades culturales guardadas correctamente.",
          saved: TypeActivitysToSave.length
        };
      } catch (error) {
        console.error("Error al guardar actividades culturales:", error);
        throw error;
      }

      // Simulación temporal - Elimina esto cuando implementes la llamada real
      // const simulatedResponse = {
      //   status: 200,
      //   data: {
      //     message: "Actividades culturales guardadas correctamente",
      //     saved: TypeActivitysToSave.length
      //   }
      // }
      
      // return simulatedResponse.data;
    },

    async saveObservations(vstID) {
      console.log("--- GUARDANDO OBSERVACIONES ---");
      const userID = this.$fun.getUserID();

      const observationsToSave = this.observations.map((obs, index) => ({
        VstID: vstID,
        RobObs: obs.RobObs,
        RobID: obs.RobID || 0,
        UsrCreateID: userID,
        UsrUpdateID: userID,
        SecStatus: obs.SecStatus !== 0 ? 1 : 0, // ✅ marcar inactivas
        Line: index + 1,
        UUID:obs.UUID || null
      }));

      if (observationsToSave.length === 0) {
        return {
          message: "No hay observaciones para guardar.",
          saved: 0
        };
      }

      try {
        for (const obs of observationsToSave) {
          await _visitObservations.save(obs, userID);
          console.log("Observación guardada:", obs);
        }
        return {
          message: "Observaciones guardadas correctamente.",
          saved: observationsToSave.length
        };
      } catch (error) {
        console.error("Error al guardar observaciones:", error);
        throw error;
      }

      // Simulación temporal - Elimina esto cuando implementes la llamada real
      // const simulatedResponse = {
      //   status: 200,
      //   data: {
      //     message: "Observaciones guardadas correctamente",
      //     saved: observationsToSave.length
      //   }
      // }
      
      // return simulatedResponse.data;
    },
    resetDeletedArrays() {
      this.deletedApplications = [];
      this.deletedPhytosanitaryEvaluations = [];
      this.deletedPerformedActivities = [];
      this.deletedRecommendations = [];
    },
    initializeForm() {
      // Limpiar arrays de eliminados
      this.resetDeletedArrays();
      
      if (this.isEdit && this.visitData) {
        this.loadVisitData(this.visitData);
      } else {
        this.resetForm();
      }
    },
    
    loadVisitData(data) {
      if (this.isEdit) {
        // Si estamos en modo edición, usar el método completo
        this.loadVisitDataForEdit(data);
      } else {
        // Si es nuevo, solo cargar datos básicos
        this.loadBasicVisitData(data);
        
        // Cargar información del lote si existe
        if (data.FltID) {
          this.loadLotInfoForEdit(data);
        }
      }
    },
    
    resetForm() {
      this.formData = {
        VstID: null,
        VstDate: null,
        VstSerie: "",
        VstNumber: "",
        TvID: null,
        VstSupervisorPrsID: null,
        GenID: null,
        PrdSignature: false,
        VstObservation: "",
        FltID: null,
        ZonID: null,
        SzoID: null,
        CmaID: null,
        PlID: this.PlID
      };
      
      this.lotInfo = {
        FltID: '',
        FltName: "",
        VrtName: "",
        PrdCardName: "",
        FagName: "",
        FagAddress: "",
        ZonDescription: "",
        SzoDescription: "",
        TypeCropName: "",
        TypeCultive: null,
        ZonID: null,
        SzoID: null
      };
      
      this.messageFarmLot = "";
      
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }

      this.applications = [];
      this.deletedApplications = [];
      this.phenologyData = {};
      this.totalPhenologyPercent = 0;
      this.phytosanitaryEvaluations = [];
      this.deletedPhytosanitaryEvaluations = [];
      this.performedActivities = [];
      this.deletedPerformedActivities = [];
      this.installationTypes = [];
      this.allRecommendations = [];
      this.deletedRecommendations = [];
      this.RchNote = '';
      this.itemsTypeActivities.forEach(item => {
        item.AcuStatus = false;
        item.AcuID = 0;
      });
      this.observations = [];
      this.editIndex = null;
      this.RobObs = "";
    },
    
    onDateChange(date) {
      if (this.lotInfo.FltID && date) {
        this.getVisitFarmLot({
          ...this.lotInfo,
          VstDate: date
        });
      }
    },
    
    searchSenasa(lot) {
      console.log("searchSenasa", lot);
      if(!lot) return;

      // Limpiar todas las tablas/secciones
      this.applications = [];
      this.deletedApplications = [];
      this.phenologyData = {};
      this.totalPhenologyPercent = 0;
      this.phytosanitaryEvaluations = [];
      this.deletedPhytosanitaryEvaluations = [];
      this.performedActivities = [];
      this.deletedPerformedActivities = [];
      this.installationTypes = [];
      this.allRecommendations = [];
      this.deletedRecommendations = [];
      this.RchNote = '';
      this.itemsTypeActivities.forEach(item => {
        item.AcuStatus = false;
        item.AcuID = 0;
      });
      this.observations = [];
      this.editIndex = null;
      this.RobObs = "";

      // Actualizar info del lote
      this.lotInfo = {
        ...lot,
        TypeCropName: lot.TypeCropText,
        VrtName: lot.VrtDescription,
        ZonDescription: lot.ZonIDText,
        SzoDescription: lot.SzoIDText
      };
      console.log("this.lotInfo", this.lotInfo);
      this.formData.FltID = lot.FltID;
      this.formData.ZonID = lot.ZonID;
      this.formData.SzoID = lot.SzoID;

      if (this.formData.VstDate) {
        this.getVisitFarmLot({
          ...lot,
          VstDate: this.formData.VstDate
        });

        this.loadInstallationTypes();
      }
    },
    
    getVisitFarmLot(lot) {
      this.messageFarmLot = "";
      _sServices.getVisitFarmLot(lot, this.$fun.getUserID()).then((r) => {
        console.log("Respuesta de getVisitFarmLot:", r);
        if (r.status === 200 && r.data) {
          this.messageFarmLot = `Última Visita del Productor: ${this.$fun.formatDateView(r.data.VstDate)}, Días: ${r.data.DaysLastDateVisit}`;
        }
      }).catch((error) => {
        console.error("Error al obtener información de visita:", error);
      });
    },
    
    validateForm() {
      const errors = [];
      
      // if (!this.formData.VstSerie) {
      //   errors.push("Debe ingresar una Serie");
      // }
      
      // if (!this.formData.VstNumber) {
      //   errors.push("Debe ingresar un número de documento");
      // }
      
      if (!this.lotInfo.FltID) {
        errors.push("Debe seleccionar un Lote");
      }
      
      if (!this.formData.VstSupervisorPrsID) {
        errors.push("Debe seleccionar un Supervisor");
      }
      
      if (!this.formData.VstDate) {
        errors.push("Debe seleccionar una fecha");
      }
      
      if (errors.length > 0) {
        this.$fun.alert(errors.join('\n'), "warning");
        return false;
      }
      
      return true;
    },
    
    closeModal() {
      this.$fun.alertFull("¿Seguro de salir?", "question").then(async (resp) => {
        if (resp.value) {
            this.dialogVisible = false;
            this.$emit('close');
            this.resetForm();
        }
      });
    },
    closeModalSave() {
      this.dialogVisible = false;
      this.$emit('close');
      this.resetForm();
    },
    openApplicationModal(application = null, index = -1) {
      this.selectedApplication = application || {};
      this.isEditingApplication = !!application;
      this.editingApplicationIndex = index;
      this.applicationModalOpen = true;
    },
    
    editApplication(application, index) {
      this.openApplicationModal(application, index);
    },
    
    deleteApplication(index) {
      // this.$fun.confirm("¿Está seguro de eliminar esta aplicación?", () => {
        const application = this.applications[index];
        console.log("application", application);
        // Si tiene ID, marcarlo para eliminación
        if (application.PapID) {
          console.log("PapID", application.PapID);
          this.deletedApplications.push({
            ...application,
            SecStatus: 0
          });
          console.log("deletedApplications", this.deletedApplications);
        }
        console.log("applications", this.applications);
        console.log("deletedApplications", this.deletedApplications);
        // Remover de la lista
        this.applications.splice(index, 1);
        
        // Reordenar líneas
        this.reorderApplicationLines();
        
        this.$fun.alert("Aplicación eliminada correctamente", "success");
      // });
    },
    onApplicationSaved(applicationData) {
      const details = applicationData.TasVisitProductApplications.filter(detail => detail.SecStatus === 1) || [];

      const LsNames = details
        .map(d => d.LsName || d.PpaObservation)
        .filter(Boolean)
        .join(', ');

      const TypeApplicationNames = [
        ...new Set(details.map(d => d.TypeApplicationName).filter(Boolean))
      ].join(', ');

      const totalDose = details.reduce((sum, d) => sum + parseFloat(d.PpaDose || 0), 0);
      const totalAmount = details.reduce((sum, d) => sum + parseFloat(d.AmountTotal || 0), 0);

      const newApp = {
        ...applicationData,
        Line: this.isEditingApplication ? this.editingApplicationIndex + 1 : this.applications.length + 1,
        LsName: LsNames,
        TypeApplicationName: TypeApplicationNames,
        PpaDose: totalDose,
        AmountTotal: totalAmount,
        PapID: applicationData.PapID || 0,
        UsrCreateID: this.$fun.getUserID()
      };

      if (this.isEditingApplication && this.editingApplicationIndex >= 0) {
        this.applications.splice(this.editingApplicationIndex, 1, newApp);
        this.$fun.alert("Aplicación actualizada correctamente", "success");
      } else {
        this.applications.push(newApp);
        this.$fun.alert("Aplicación agregada correctamente", "success");
      }

      this.reorderApplicationLines();
    },
    
    onApplicationModalClose() {
      this.selectedApplication = {};
      this.isEditingApplication = false;
      this.editingApplicationIndex = -1;
    },
    
    reorderApplicationLines() {
      this.applications.forEach((app, index) => {
        app.Line = index + 1;
      });
    },

    loadPhenologyStages() {
      _sDefinition.definitiongroup(1207, 0, this.$fun.getUserID()).then((r) => {
        this.phenologyStages = r.data.map(item => ({
          label: item.DedDescription,
          value: item.DedValue,
          helper: item.DedHelper
        }));
        
        // Inicializar los datos de fenología
        this.initializePhenologyData();
      }).catch((error) => {
        console.error("Error al cargar etapas fenológicas:", error);
      });
    },

    loadRecomendationAplications() {
      _sDefinition.definitiongroup(1214, 0, this.$fun.getUserID()).then((r) => {
        this.recomendationAplications = r.data.map(item => ({
          label: item.DedDescription,
          value: item.DedValue,
          helper: item.DedHelper
        }));
        console.log("Recomendaciones cargadas:", this.recomendationAplications);
      }).catch((error) => {
        console.error("Error al cargar recomendaciones:", error);
      });
    },
    
    initializePhenologyData() {
      const initialData = {};
      this.phenologyStages.forEach(stage => {
        initialData[stage.value] = 0;
      });
      this.phenologyData = initialData;
    },
    
    onPhenologyChange(newValue, fieldKey) {
      const totalWithoutCurrent = Object.entries(this.phenologyData)
        .filter(([key]) => key !== fieldKey)
        .reduce((sum, [_, value]) => sum + parseFloat(value || 0), 0);
      const newTotal = totalWithoutCurrent;
      console.log("newTotal", newTotal);
      if (newTotal > 100) {
        console.log("Supera el 100%");
        // Supera el 100%, limpiamos el campo actual
        this.phenologyData[fieldKey] = 0;
        console.log("this.phenologyData[fieldKey]", this.phenologyData[fieldKey]);

        // Forzar que el campo pierda el foco
        this.$nextTick(() => {
          const input = document.activeElement;
          if (input && input.blur) {
            input.blur();
          }
        });
      } else {
        console.log("Aceptamos el valor");
        // Aceptamos el valor
        this.phenologyData[fieldKey] = newValue;
      }

      this.calculateTotalPhenologyPercent();
    },
    
    calculateTotalPhenologyPercent() {
      this.totalPhenologyPercent = Object.values(this.phenologyData)
        .reduce((sum, value) => sum + parseFloat(value || 0), 0);
    },
    
    validatePercentage(value) {
      const num = parseFloat(value);
      if (num === '') {
        return true;
      }
      console.log("num", num);
      if (isNaN(num) || (num < 0)) {
        return 'El porcentaje debe ser un número mayor o igual a 0';
      }
      if (num > 100) {
        return 'El porcentaje no puede ser mayor a 100';
      }
      return true;
    },
    
    editPhytosanitaryEvaluation(evaluation, index) {
      this.currentPhytosanitary = { ...evaluation };
      this.showPhytosanitaryForm = true;
      this.editingPhytosanitaryIndex = index;
    },
    
    savePhytosanitaryEvaluation() {
      if (!this.validatePhytosanitaryEvaluation()) {
        return;
      }

      // Obtener nombres de los items seleccionados
      let plagueName = this.currentPhytosanitary.PlID.PlDescription || '';

      let organName = '';

      if (this.itemsTypeOrganPlant) {
        organName = this.itemsTypeOrganPlant.find(item => item.DedValue === this.currentPhytosanitary.TypeOrganPlant);
      }

      console.log("plagueName Name:", plagueName);
      
      const evaluationData = {
        ...this.currentPhytosanitary,
        PlName: plagueName || this.currentPhytosanitary.PlName || 'Nombre no disponible',
        TypeOrganName: organName.DedDescription || this.currentPhytosanitary.TypeOrganName || 'Órgano no disponible',
        Line: this.editingPhytosanitaryIndex >= 0 ? this.editingPhytosanitaryIndex + 1 : this.phytosanitaryEvaluations.length + 1,
        PheID: this.currentPhytosanitary.PheID || 0,
        VstID: this.formData.VstID || null,
        SecStatus: 1,
        UsrCreateID: this.$fun.getUserID(),
        UUID:this.currentPhytosanitary.PheID?this.currentPhytosanitary.UUID:uuidv4()
      };

      console.log("evaluationData", evaluationData);
      
      if (this.editingPhytosanitaryIndex >= 0) {
        this.phytosanitaryEvaluations.splice(this.editingPhytosanitaryIndex, 1, evaluationData);
        this.$fun.alert("Evaluación actualizada correctamente", "success");
      } else {
        this.phytosanitaryEvaluations.push(evaluationData);
        this.$fun.alert("Evaluación agregada correctamente", "success");
      }
      
      this.reorderPhytosanitaryLines();
      this.cancelPhytosanitaryForm();
    },
    
    deletePhytosanitaryEvaluation(index) {
        const evaluation = this.phytosanitaryEvaluations[index];
        
        if (evaluation.PheID) {
          this.deletedPhytosanitaryEvaluations.push({
            ...evaluation,
            SecStatus: 0
          });
        }
        
        this.phytosanitaryEvaluations.splice(index, 1);
        
        this.reorderPhytosanitaryLines();
        
        this.$fun.alert("Evaluación eliminada correctamente", "success");
    },
    
    validatePhytosanitaryEvaluation() {
      if (!this.currentPhytosanitary.PlID) {
        this.$fun.alert("Enfermedad/Plaga/Maleza es obligatorio", "warning");
        return false;
      }
      
      if (!this.currentPhytosanitary.PhePercentage && this.currentPhytosanitary.PhePercentage !== 0) {
        this.$fun.alert("Porcentaje no válido", "warning");
        if (this.$refs.PhePercentage) {
          this.$refs.PhePercentage.focus();
        }
        return false;
      }
      
      if (this.currentPhytosanitary.PhePercentage < 0 || this.currentPhytosanitary.PhePercentage > 100) {
        this.$fun.alert("Porcentaje debe estar entre 0 y 100", "warning");
        return false;
      }
      
      return true;
    },
    
    cancelPhytosanitaryForm() {
      this.showPhytosanitaryForm = false;
      this.editingPhytosanitaryIndex = -1;
      this.resetCurrentPhytosanitary();
    },
    
    resetCurrentPhytosanitary() {
      this.currentPhytosanitary = {
        PlID: null,
        TypeOrganPlant: null,
        PhePercentage: 0,
        PlName: '',
        TypeOrganName: ''
      };
    },
    
    reorderPhytosanitaryLines() {
      this.phytosanitaryEvaluations.forEach((evaluation, index) => {
        evaluation.Line = index + 1;
      });
    },

    getDataTypeOrganPlant(items)
    {
      this.itemsTypeOrganPlant = items;
    },

    savePerformedActivity() {
      if (!this.validatePerformedActivity()) return;

      const activityData = {
        ...this.currentPerformedActivity,
        TypeActivity: this.currentPerformedActivity.objTypeActivity.DedValue,
        TypeActivityName: this.currentPerformedActivity.objTypeActivity.DedDescription,
        Line: this.editingPerformedActivityIndex >= 0 
              ? this.editingPerformedActivityIndex + 1 
              : this.performedActivities.length + 1,
        PacID: this.currentPerformedActivity.PacID || 0,
        UsrCreateID: this.$fun.getUserID(),
        SecStatus: 1,
        UUID: this.currentPerformedActivity.PacID? this.currentPerformedActivity.UUID : uuidv4()
      };

      if (this.editingPerformedActivityIndex >= 0) {
        this.performedActivities.splice(this.editingPerformedActivityIndex, 1, activityData);
        this.$fun.alert("Actividad actualizada correctamente", "success");
      } else {
        this.performedActivities.push(activityData);
        this.$fun.alert("Actividad agregada correctamente", "success");
      }

      this.resetCurrentPerformedActivity();
      this.editingPerformedActivityIndex = -1;
    },
    validatePerformedActivity() {
      const errors = [];
      
      if (!this.currentPerformedActivity.objTypeActivity || !this.currentPerformedActivity.objTypeActivity.DedValue) {
        errors.push("Debe seleccionar un tipo de actividad");
      }

      if (!this.currentPerformedActivity.PacBeginDate) {
        errors.push("La fecha de inicio es requerida");
      }

      // Validaciones específicas por tipo de actividad
      const activityType = this.currentPerformedActivity.objTypeActivity.DedValue;
      
      if (activityType === 1) { // Riego
        if (!this.currentPerformedActivity.TypeIrrigation) {
          errors.push("Debe seleccionar un sistema de riego");
        }
      } else if (activityType === 2) { // Poda
        if (!this.currentPerformedActivity.PacNumberOfTrees) {
          errors.push("Debe ingresar el número de árboles podados");
        }
      } // ... agregar más validaciones según necesites

      if (errors.length > 0) {
        this.$fun.alert(errors.join('\n'), "warning");
        return false;
      }

      return true;
    },
    cancelPerformedActivityForm() {
      this.editingPerformedActivityIndex = -1;
      this.resetCurrentPerformedActivity();
    },
    // Editar actividad
    editPerformedActivity(activity, index) {
      this.currentPerformedActivity = { ...activity, objTypeActivity: { 
        DedValue: activity.TypeActivity, 
        DedDescription: activity.TypeActivityName 
      }};
      this.editingPerformedActivityIndex = index;
    },
    // Eliminar actividad
    deletePerformedActivity(index) {
      const activity = this.performedActivities[index];
      
      if (activity.PacID) {
        this.deletedPerformedActivities.push({
          ...activity,
          SecStatus: 0
        });
      }
      
      this.performedActivities.splice(index, 1);
      this.$fun.alert("Actividad eliminada correctamente", "success");
    },
    resetCurrentPerformedActivity() {
      this.currentPerformedActivity = {
        objTypeActivity: {},
        TypeActivity: null,
        PacBeginDate: null,
        PacEndDate: null,
        // ... (resetear todos los demás campos)
        PacID: null
      };
    },
    getActivityIcon(type) {
      const icons = {
        1: 'water',
        2: 'tree',
        3: 'grass',
        4: 'bug'
      };
      return icons[type] || 'clipboard-list';
    },

    // Cargar tipos de instalación
    async loadInstallationTypes() {
      this.loadingInstallations = true;
      try {
        const response = await _sDefinition.definitiongroup(1209, 0, this.$fun.getUserID());
        if (response.status === 200) {
          console.log("Tipos de instalación cargados:", response.data);
          this.installationTypes = response.data.map(item => ({
            ...item,
            IneStatus: false,
            IneID: null,
            UUID:null
          }));
          
          // Si estamos editando, cargar evaluaciones existentes
          // if (this.formData.VstID) {
          //   await this.loadExistingInstallationEvaluations();
          // }
        }
      } catch (error) {
        console.error("Error al cargar tipos de instalación:", error);
      } finally {
        this.loadingInstallations = false;
      }
    },

    // Cargar evaluaciones existentes
    async loadExistingInstallationEvaluations() {
      try {
        const response = await _visitApplication.list({ VstID: this.formData.VstID }, this.$fun.getUserID());
        if (response.status === 200 && response.data.length > 0) {
          this.installationTypes.forEach(type => {
            const existingEval = response.data.find(e => e.TypeInstallation === type.DedValue);
            if (existingEval) {
              type.IneStatus = existingEval.IneStatus === 1;
              type.IneID = existingEval.IneID;
            }
          });
        }
      } catch (error) {
        console.error("Error al cargar evaluaciones existentes:", error);
      }
    },

    // Guardar evaluación de instalación
    async saveInstallationEvaluation(item) {
      const payload = {
        VstID: this.formData.VstID,
        TypeInstallation: item.DedValue,
        IneStatus: item.IneStatus ? 1 : 0,
        IneID: item.IneID || 0,
        UsrCreateID: this.$fun.getUserID(),
        SecStatus: 1, 
        UUID: item.IneID ? item.UUID : uuidv4()
      };
    },

    openRecomendationModal(item) {
      this.selectedRecomendation = item;
      this.recomendationModalOpen = true;
      this.resetCurrentRecommendation();
    },

    // Cerrar modal
    closeRecomendationModal() {
      this.recomendationModalOpen = false;
      this.selectedRecomendation = null;
      this.editingRecommendationIndex = -1;
      this.resetCurrentRecommendation();
      
      // Resetear validación del formulario
      if (this.$refs.recommendationForm) {
        this.$refs.recommendationForm.resetValidation();
      }
    },

    // Resetear formulario
    resetCurrentRecommendation() {
      this.currentRecommendation = {
        // plague: null,
        // product: null,
        dose: null,
        typeOrder: null,
        typeOrderName: '',
        // plagueName: '',
        // productName: '',
        typeApplication: this.selectedRecomendation ? this.selectedRecomendation.value : null,
        typeApplicationName: this.selectedRecomendation ? this.selectedRecomendation.label : ''
      };
    },

    // Manejar selección de plaga
    inputPlague(plague) {
      if (plague) {
        this.currentRecommendation.plagueName = plague.PlDescription || plague.PlName || '';
      } else {
        this.currentRecommendation.plagueName = '';
      }
    },

    // Manejar selección de producto
    inputProductRecomendation(product) {
      console.log("inputProductRecomendation", product);
      if (product) {
        this.currentRecommendation.productName = product.LsDescription || '';
      } else {
        this.currentRecommendation.productName = '';
      }
    },

    // Manejar selección de orden (agregar este método)
    inputTypeOrder(order) {
      if (order) {
        this.currentRecommendation.typeOrderName = order.DedDescription || order.label || '';
      } else {
        this.currentRecommendation.typeOrderName = '';
      }
    },

    // Guardar recomendación
    saveRecommendation() {
      // Validar formulario
      if (!this.$refs.recommendationForm.validate()) {
        return;
      }

      const recommendationData = {
        ...this.currentRecommendation,
        RcmID: this.currentRecommendation.RcmID || 0,
        vstId: this.formData.VstID || null,
        secStatus: 1,
        usrCreateId: this.$fun.getUserID(),
        createdAt: new Date().toISOString(),
        UUID: this.currentRecommendation.RcmID? this.currentRecommendation.UUID : uuidv4()
      };
      if (this.editingRecommendationIndex >= 0) {
        // Actualizar recomendación existente
        this.allRecommendations.splice(this.editingRecommendationIndex, 1, recommendationData);
        this.$fun.alert("Recomendación actualizada correctamente", "success");
      } else {
        // Agregar nueva recomendación
        this.allRecommendations.push(recommendationData);
        this.$fun.alert("Recomendación agregada correctamente", "success");
      }

      // Cerrar modal
      this.closeRecomendationModal();
    },

    // Editar recomendación desde la tabla
    editRecommendation(recommendation, index) {
      // Encontrar el tipo de aplicación correspondiente
      const applicationType = this.recomendationAplications.find(
        app => app.value === recommendation.typeApplication
      );
      
      if (applicationType) {
        this.selectedRecomendation = applicationType;
        this.currentRecommendation = { ...recommendation };
        this.editingRecommendationIndex = index;
        this.recomendationModalOpen = true;
      }
    },

    // Eliminar recomendación
    deleteRecommendation(index) {
      // this.$fun.confirm("¿Está seguro de eliminar esta recomendación?", () => {
        const recommendation = this.allRecommendations[index];
        console.log("recommendation", recommendation);
        // Si tiene ID, marcarlo para eliminación en el servidor
        if (recommendation.RcmID) {
          this.deletedRecommendations.push({
            ...recommendation,
            secStatus: 0
          });
        }
        console.log("deletedRecommendations", this.deletedRecommendations);
        // Remover de la lista
        this.allRecommendations.splice(index, 1);
        
        this.$fun.alert("Recomendación eliminada correctamente", "success");
      // });
    },

    // Método para cargar recomendaciones existentes (si estás editando una visita)
    loadExistingRecommendations(visitData) {
      if (visitData && visitData.recommendations) {
        this.allRecommendations = visitData.recommendations.map(rec => ({
          plague: { PlID: rec.PlID, PlDescription: rec.PlagueName },
          product: { LsID: rec.LsID, LsName: rec.ProductName },
          dose: rec.RcmDose,
          typeOrder: rec.TypeOrder,
          typeOrderName: rec.TypeOrderName || '',
          plagueName: rec.PlagueName,
          productName: rec.ProductName,
          typeApplication: rec.TypeApplication,
          typeApplicationName: rec.TypeApplicationName,
          RcmID: rec.RcmID,
          VstId: rec.VstID,
          secStatus: rec.SecStatus,
          usrCreateId: rec.UsrCreateID
        }));
      }
    },
    loadDef(){
      _sDefinition.definitiongroup(1204, 0, this.$fun.getUserID()).then((r) => {
          r.data.forEach((item) => {                 
              item.AcuStatus = false;
              item.AcuID = 0;
          });
              
          this.itemsTypeActivities = r.data;
          if(this.formData.VstID)
            this.loadActv(this.formData.VstID);
      });
    },
    loadActv(vstID){
      _visitApplication.pagination({ VstID: vstID } , this.$fun.getUserID()).then((r) => {
          if (r.status == 200) {
              this.itemsTypeActivities.forEach((item) => {
                  item.SecStatus = 1;
                  item.UsrCreateID = this.$fun.getUserID();
                  r.data.forEach(element => {
                      if (item.DedValue == element.TypeActivity) {
                          item.AcuStatus = element.AcuStatus == 1 ? true : false;
                          item.AcuID = element.AcuID;
                          item.UUID = element.UUID;
                      }
                  });
              });
          }
      });
    },
    addObservation() {
      if (this.editIndex !== null) {
        // Editar observación existente
        this.observations[this.editIndex].RobObs = this.RobObs;
        this.editIndex = null;
      } else {
        // Agregar nueva observación con SecStatus = 1
        this.observations.push({
          id: Date.now(),
          RobObs: this.RobObs,
          SecStatus: 1,
          UUID:uuidv4()
        });
      }
      this.RobObs = "";
    },
    editObservation(item, index) {
      this.RobObs = item.RobObs;
      this.editIndex = index;
    },

    deleteObservation(index) {
      const obs = this.observations[index];
      console.log("obs", obs);
      if (obs.RobID > 0) {
        // Marcar como eliminada lógicamente
        this.observations[index].SecStatus = 0;
        console.log("this.observations[index]", this.observations[index]);
      } else {
        // Si es nueva y aún no se ha guardado, simplemente eliminar del arreglo
        this.observations.splice(index, 1);
      }

      if (this.editIndex === index) {
        this.RobObs = "";
        this.editIndex = null;
      }
    },
    cancelObservationRecord() {
      this.editIndex = -1;
      this.RobObs = "";
    },
    getPaginationParams(vstID) {
      const params = {
        filter: this.filter,
        draw: 1,
        start: (this.options.page - 1) * this.options.itemsPerPage,
        length: this.options.itemsPerPage,
        order: [],
        searchText: this.filter.searchText,
        VstID: vstID
      };

      if (this.options.sortBy.length > 0) {
        params.order = [{
          column: this.options.sortBy[0],
          dir: this.options.sortDesc[0] ? 'desc' : 'asc'
        }];
      }

      return params;
    },
    async loadVisitDataForEdit(visitData) {
      console.log("=== INICIANDO CARGA DE DATOS PARA EDICIÓN ===");
      console.log("Datos de visita recibidos:", visitData);
      
      try {
        console.log("VisitID", this.VisitID);
        if(this.VisitID != 0){

          const response = await _sServices.visitFind(this.VisitID, this.$fun.getUserID());
          console.log("Respuesta de servicios:", response);
          visitData = response.data;
          console.log("visitData", visitData);
        } 
        // 1. Cargar datos básicos de la cabecera
        this.loadBasicVisitData(visitData);
        
        // 2. Cargar información del lote si existe
        if (visitData.FltID) {
          await this.loadLotInfoForEdit(visitData);
        }
        
        // 3. Cargar todas las secciones en paralelo para mejor rendimiento
        const loadPromises = [];
        
        if (visitData.VstID) {
          loadPromises.push(this.loadApplicationsForEdit(visitData.VstID));
          loadPromises.push(this.loadPhenologyForEdit(visitData.VstID));
          loadPromises.push(this.loadPhytosanitaryForEdit(visitData.VstID));
          loadPromises.push(this.loadPerformedActivitiesForEdit(visitData.VstID));
          loadPromises.push(this.loadInstallationEvaluationsForEdit(visitData.VstID));
          loadPromises.push(this.loadRecommendationsForEdit(visitData.VstID));
          loadPromises.push(this.loadCulturalActivitiesForEdit(visitData.VstID));
          loadPromises.push(this.loadObservationsForEdit(visitData.VstID));
        }
        
        // Ejecutar todas las cargas en paralelo
        await Promise.all(loadPromises);
        
        console.log("✅ CARGA DE DATOS PARA EDICIÓN COMPLETADA");
        
      } catch (error) {
        console.error("❌ ERROR AL CARGAR DATOS PARA EDICIÓN:", error);
        this.$fun.alert(`Error al cargar datos de la visita: ${error.message}`, "error");
      }
    },

    // 2. Cargar datos básicos de la cabecera
    loadBasicVisitData(visitData) {
      console.log("--- CARGANDO DATOS BÁSICOS ---");
      
      this.formData = {
        VstID: visitData.VstID,
        VstDate: visitData.VstDate,
        VstSerie: visitData.VstSerie || "",
        VstNumber: visitData.VstNumber || "",
        TvID: visitData.TvID,
        VstSupervisorPrsID: visitData.VstSupervisorPrsID,
        GenID: visitData.CmaID || visitData.GenID,
        PrdSignature: visitData.PrdSignature || false,
        VstObservation: visitData.VstObservation || "",
        FltID: visitData.FltID,
        ZonID: visitData.ZonID,
        SzoID: visitData.SzoID,
        CmaID: visitData.CmaID,
        PlID: visitData.PlID || this.PlID
      };
      this.location.latitude = visitData.VstLatitude;
      this.location.longitude = visitData.VstLongitude;

      console.log("Datos básicos cargados:", this.formData);
    },

    // 3. Cargar información del lote para edición
    async loadLotInfoForEdit(visitData) {
      console.log("--- CARGANDO INFORMACIÓN DEL LOTE ---");
      
      try {
        // Si ya tienes los datos del lote en visitData, úsalos
        if (visitData.FltName) {
          this.lotInfo = {
            FltID: visitData.FltID,
            FltName: visitData.FltName || "",
            VrtName: visitData.VrtName || "",
            PrdCardName: visitData.PrdCardName || "",
            FagName: visitData.FagName || "",
            FagAddress: visitData.FagAddress || "",
            ZonDescription: visitData.ZonDescription || "",
            SzoDescription: visitData.SzoDescription || "",
            TypeCropName: visitData.TypeCropName || "",
            TypeCultive: visitData.TypeCultive,
            ZonID: visitData.ZonID,
            SzoID: visitData.SzoID
          };
        } else {
          // Si no tienes los datos completos, buscar el lote por ID
          // Aquí deberías llamar a tu servicio para obtener los datos del lote
          // const lotResponse = await _sServices.getLotById(visitData.FltID, this.$fun.getUserID());
          // this.lotInfo = lotResponse.data;
        }
        
        console.log("Información del lote cargada:", this.lotInfo);
        
      } catch (error) {
        console.error("Error al cargar información del lote:", error);
      }
    },

    // 4. Cargar aplicaciones para edición
    async loadApplicationsForEdit(vstID) {
      console.log("--- CARGANDO APLICACIONES ---");

      try {
        this.filter.VstID = vstID || this.formData.VstID;

        const paginationParams = this.getPaginationParams(vstID);

        const response = await _visitApplication.pagination(paginationParams, this.$fun.getUserID());
        console.log("Respuesta de aplicaciones:", response);

        if (response.status === 200 && response.data.data?.length > 0) {
          const applications = response.data.data.map(app => ({
            ...app,
            LsName: app.LsName || app.ProductName || "",
            TypeApplicationName: app.TypeApplicationName || "",
            PpaDose: app.PpaDose || 0,
            AmountTotal: app.AmountTotal || 0,
            Line: app.Line || 0,
            UUID: app.UUID || null,
            TasVisitProductApplications: [] // inicializar arreglo de detalles
          }));

          // Cargar detalles individualmente para cada aplicación
          await Promise.all(applications.map(async (app) => {
            const r = await _visitApplication.listProductApplication(app, this.$fun.getUserID());
            if (r.status === 200 && Array.isArray(r.data)) {
              app.TasVisitProductApplications = r.data;

              // Calcular sumas
              app.PpaDose = parseFloat(
                app.TasVisitProductApplications.reduce((sum, d) => sum + (d.PpaDose || 0), 0).toFixed(3)
              );
              app.AmountTotal = parseFloat(
                app.TasVisitProductApplications.reduce((sum, d) => sum + (d.AmountTotal || 0), 0).toFixed(3)
              );

              // Concatenar nombres de productos (LsName o PpaObservation)
              app.LsName = app.TasVisitProductApplications
                .map(d => d.LsName || d.PpaObservation)
                .filter(Boolean)
                .join(', ');

              // Concatenar tipos de aplicación únicos
              app.TypeApplicationName = [
                ...new Set(app.TasVisitProductApplications.map(d => d.TypeApplicationName).filter(Boolean))
              ].join(', ');
            }
          }));

          this.applications = applications;

          console.log("✅ Aplicaciones con detalles:", this.applications.length);
        } else {
          this.applications = [];
          console.log("⚠️ No se encontraron aplicaciones");
        }

      } catch (error) {
        console.error("❌ Error al cargar aplicaciones:", error);
        this.applications = [];
      }
    },

    // 5. Cargar datos fenológicos para edición
    async loadPhenologyForEdit(vstID) {
      console.log("--- CARGANDO DATOS FENOLÓGICOS ---");
      
      try {
        this.filter.VstID = vstID || this.formData.VstID;

        const paginationParams = this.getPaginationParams(vstID);

        const response = await _visitPhenology.pagination(paginationParams, this.$fun.getUserID());
        console.log("Respuesta de datos fenológicos:", response);
        if (response.status === 200 && response.data.data?.length > 0) {
          // Resetear datos fenológicos
          this.initializePhenologyData();
          
          // Cargar los datos existentes
          response.data.data.forEach(item => {
            const type = item.TypeStatePhenological;
            if (this.phenologyData.hasOwnProperty(type)) {
              this.phenologyData[type] = item.StpPercentage || 0;
              this.phenologyIDs[type] = item.StpID; // ✅ guardar ID
              this.phenologyUUIDs[type] = item.UUID;
            }
          });
          
          // Recalcular total
          this.calculateTotalPhenologyPercent();
          
          console.log("✅ Datos fenológicos cargados:", this.phenologyData);
        } else {
          this.initializePhenologyData();
          console.log("⚠️ No se encontraron datos fenológicos");
        }
        
      } catch (error) {
        console.error("❌ Error al cargar datos fenológicos:", error);
        this.initializePhenologyData();
      }
    },

    // 6. Cargar evaluaciones fitosanitarias para edición
    async loadPhytosanitaryForEdit(vstID) {
      console.log("--- CARGANDO EVALUACIONES FITOSANITARIAS ---");
      
      try {
        this.filter.VstID = vstID || this.formData.VstID;
        const paginationParams = this.getPaginationParams(vstID);

        const response = await _visitPhytosanitary.pagination(paginationParams, this.$fun.getUserID());
        console.log("Respuesta de evaluaciones fitosanitarias:", response);
        if (response.status === 200 && response.data.data?.length > 0) {
          this.phytosanitaryEvaluations = response.data.data.map(evaluation => ({
            ...evaluation,
            // Asegurar compatibilidad con el formulario
            PlName: evaluation.PlName || evaluation.PlagueName || "",
            TypeOrganName: evaluation.TypeOrganName || "",
            PhePercentage: evaluation.PhePercentage || 0,
            Line: evaluation.Line || 0,
            UUID: evaluation.UUID || null
          }));
          
          console.log("✅ Evaluaciones fitosanitarias cargadas:", this.phytosanitaryEvaluations.length);
        } else {
          this.phytosanitaryEvaluations = [];
          console.log("⚠️ No se encontraron evaluaciones fitosanitarias");
        }
        
      } catch (error) {
        console.error("❌ Error al cargar evaluaciones fitosanitarias:", error);
        this.phytosanitaryEvaluations = [];
      }
    },

    // 7. Cargar actividades realizadas para edición
    async loadPerformedActivitiesForEdit(vstID) {
      console.log("--- CARGANDO ACTIVIDADES REALIZADAS ---");
      
      try {
        this.filter.VstID = vstID || this.formData.VstID;
        const paginationParams = this.getPaginationParams(vstID);

        const response = await _visitPerformedActivity.pagination(paginationParams, this.$fun.getUserID());
        
        if (response.status === 200 && response.data.data?.length > 0) {
          this.performedActivities = response.data.data.map(activity => ({
            ...activity,
            // Reconstruir objTypeActivity para compatibilidad con el formulario
            objTypeActivity: {
              DedValue: activity.TypeActivity,
              DedDescription: activity.TypeActivityName || ""
            },
            Line: activity.Line || 0,
            UUID: activity.UUID || null
          }));
          
          console.log("✅ Actividades realizadas cargadas:", this.performedActivities.length);
        } else {
          this.performedActivities = [];
          console.log("⚠️ No se encontraron actividades realizadas");
        }
        
      } catch (error) {
        console.error("❌ Error al cargar actividades realizadas:", error);
        this.performedActivities = [];
      }
    },

    // 8. Cargar evaluaciones de instalaciones para edición
    async loadInstallationEvaluationsForEdit(vstID) {
      console.log("--- CARGANDO EVALUACIONES DE INSTALACIONES ---");
      
      try {
        // Primero cargar los tipos de instalación si no están cargados
        if (!this.installationTypes.length) {
          await this.loadInstallationTypes();
        }
        
        const response = await _visitInstallationEvaluations.list({ VstID: vstID }, this.$fun.getUserID());
        
        if (response.status === 200 && response.data?.length > 0) {
          // Actualizar el estado de cada tipo de instalación
          this.installationTypes.forEach(type => {
            const evaluation = response.data.find(item  => item.TypeInstallation === type.DedValue);
            if (evaluation) {
              type.IneStatus = evaluation.IneStatus === 1;
              type.IneID = evaluation.IneID;
              type.UUID= evaluation.UUID;
            }
          });
          
          console.log("✅ Evaluaciones de instalaciones cargadas");
        } else {
          console.log("⚠️ No se encontraron evaluaciones de instalaciones");
        }
        
      } catch (error) {
        console.error("❌ Error al cargar evaluaciones de instalaciones:", error);
      }
    },

    // 9. Cargar recomendaciones para edición
    async loadRecommendationsForEdit(vstID) {
      console.log("--- CARGANDO RECOMENDACIONES ---");

      try {
        this.filter.VstID = vstID || this.formData.VstID;
        const paginationParams = this.getPaginationParams(vstID);

        const response = await _visitRecommendations.pagination(paginationParams, this.$fun.getUserID());
        console.log("Respuesta de recomendación (cabecera):", response);

        if (response.status === 200 && response.data.data?.length > 0) {
          const cabecera = response.data.data[0];

          // Guardar la nota general
          this.RchNote = cabecera.RchNote || "";
          this.RchID = cabecera.RchID;
          this.RchUUID=cabecera.UUID;

          // Obtener los detalles de la recomendación
          const r = await _visitRecommendations.listRecomendation(cabecera, this.$fun.getUserID());
          if (r.status === 200 && Array.isArray(r.data)) {
            console.log("Respuesta de recomendación (detalles):", r);
            this.allRecommendations = r.data.map(rec => ({
              plague: { PlID: rec.PlID, PlDescription: rec.PlagueName || rec.PlName },
              product: { LsID: rec.LsID, LsDescription: rec.ProductName || rec.LsName },
              dose: rec.RcmDose || 0,
              typeOrder: rec.TypeOrder ? { DedValue: rec.TypeOrder, DedDescription: rec.TypeOrderName } : null,
              typeOrderName: rec.TypeOrderName || "",
              plagueName: rec.PlagueName || rec.PlName || "",
              productName: rec.ProductName || rec.LsName || "",
              typeApplication: rec.TypeApplication,
              typeApplicationName: rec.TypeApplicationName || "",
              RcmID: rec.RcmID,
              VstId: rec.VstID,
              secStatus: rec.SecStatus,
              usrCreateId: rec.UsrCreateID,
              UUID:rec.UUID
            }));

            console.log("✅ Recomendaciones cargadas:", this.allRecommendations.length);
          } else {
            this.allRecommendations = [];
            console.warn("⚠️ No se encontraron detalles de recomendación");
          }
        } else {
          this.allRecommendations = [];
          this.RchNote = "";
          console.warn("⚠️ No se encontró cabecera de recomendación");
        }

      } catch (error) {
        console.error("❌ Error al cargar recomendaciones:", error);
        this.allRecommendations = [];
        this.RchNote = "";
      }
    },

    // 10. Cargar actividades culturales para edición
    async loadCulturalActivitiesForEdit(vstID) {
      console.log("--- CARGANDO ACTIVIDADES CULTURALES ---");
      
      try {
        this.filter.VstID = vstID || this.formData.VstID;
        const paginationParams = this.getPaginationParams(vstID);
        
        const response = await _visitTypeActivities.pagination(paginationParams, this.$fun.getUserID());
        console.log("Respuesta de actividades culturales:", response);
        if (response.status === 200 && response.data?.length > 0) {
          // Actualizar el estado de cada actividad cultural
          this.itemsTypeActivities.forEach(activity => {
            const existingActivity = response.data.find(act => act.TypeActivity === activity.DedValue);
            if (existingActivity) {
              activity.AcuStatus = existingActivity.AcuStatus === 1;
              activity.AcuID = existingActivity.AcuID;
              activity.UUID = existingActivity.UUID;
            }
          });
          
          console.log("✅ Actividades culturales cargadas");
        } else {
          console.log("⚠️ No se encontraron actividades culturales");
        }
        
      } catch (error) {
        console.error("❌ Error al cargar actividades culturales:", error);
      }
    },

    // 11. Cargar observaciones para edición
    async loadObservationsForEdit(vstID) {
      console.log("--- CARGANDO OBSERVACIONES ---");
      
      try {
        this.filter.VstID = vstID || this.formData.VstID;
        const paginationParams = this.getPaginationParams(vstID);

        const response = await _visitObservations.pagination(paginationParams, this.$fun.getUserID());
        console.log("Respuesta de observaciones:", response);
        if (response.status === 200 && response.data.data?.length > 0) {
          this.observations = response.data.data.filter(obs => obs.SecStatus === 1).map(obs => ({
            //id: obs.RobID,
            RobID: obs.RobID,
            RobObs: obs.RobObs || "",
            Line: obs.Line || 0,
            SecStatus: obs.SecStatus,
            UUID:obs.UUID
          }));
          console.log("Respuesta de observaciones:", this.observations);
          console.log("✅ Observaciones cargadas:", this.observations.length);
        } else {
          this.observations = [];
          console.log("⚠️ No se encontraron observaciones");
        }
        
      } catch (error) {
        console.error("❌ Error al cargar observaciones:", error);
        this.observations = [];
      }
    },
    getCurrentLocation() {
      console.log('Obteniendo ubicación...')
      this.loadingLocation = true;
      this.location = {};
      // Check if browser supports geolocation
      if (!navigator.geolocation) {
        this.locationError = 'Geolocation is not supported'
        console.error('Geolocalización no soportada')
        return
      }
      
      this.loadingLocation = true
      this.locationError = null
      
      // Get current location
      navigator.geolocation.getCurrentPosition(
        this.onLocationSuccess,
        this.onLocationError,
        {
          enableHighAccuracy: true, // High precision
          timeout: 10000, // 10 seconds timeout
          maximumAge: 60000 // Cache for 1 minute
        }
      )
    },
    
    onLocationSuccess(position) {
      this.loadingLocation = false
      this.location = {};
      // Store location in variable
      this.location = {
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
        accuracy: position.coords.accuracy,
        timestamp: new Date().toISOString()
      }
      
      console.log('Ubicación obtenida:', this.location)
      
      // Here you can do whatever you need with the location
      // For example, send to API, save to localStorage, etc.
    },
    
    onLocationError(error) {
      this.loadingLocation = false
      
      switch(error.code) {
        case error.PERMISSION_DENIED:
          this.locationError = 'Location permission denied'
          break
        case error.POSITION_UNAVAILABLE:
          this.locationError = 'Location unavailable'
          break
        case error.TIMEOUT:
          this.locationError = 'Location timeout'
          break
        default:
          this.locationError = 'Unknown error'
          break
      }
      
      console.error('Error al obtener ubicación:', error)
    },
  },
  mounted() {
    this.loadPhenologyStages();
    this.loadRecomendationAplications();
    this.loadDef();

    if (this.value && this.isEdit && this.visitData) {
      this.loadVisitDataForEdit(this.visitData);
    }
    if (this.preloadData?.FltID && this.$refs.searchLotSenasa) {
      console.log("🔍 codigo SENASA:", this.preloadData.FltID);
      console.log("🔍 Ingresando a SearchLotSenasa:", this.preloadData.FltID);
      this.$refs.searchLotSenasa.triggerSearch(this.preloadData.FltID);
    }
    //if(this.preloadData.length > 0) this.handler(this.preloadData);
  },
};
</script>

<style scoped>
.modern-modal {
  overflow: hidden;
}

.header-gradient {
  background: linear-gradient(135deg, #1976d2 0%, #42a5f5 100%);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.form-container {
  background: #fafafa;
  min-height: 100%;
}

.section-card {
  background: white;
  margin: 16px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.section-header {
  background: #f8f9fa;
  padding: 16px 20px;
  border-bottom: 1px solid #e9ecef;
  display: flex;
  align-items: center;
}

.section-title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #495057;
}

.section-content {
  padding: 16px 20px;
}

.info-card {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  padding: 12px;
  height: 100%;
}

.info-header {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  padding-bottom: 8px;
  border-bottom: 1px solid #dee2e6;
}

.info-title {
  font-size: 14px;
  font-weight: 600;
  color: #495057;
}

.info-content {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 24px;
}

.info-label {
  font-size: 12px;
  color: #6c757d;
  font-weight: 500;
  min-width: 80px;
}

.info-value {
  font-size: 12px;
  color: #212529;
  text-align: right;
  flex: 1;
  margin-left: 8px;
}

.switch-container {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 12px;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 6px;
}

.custom-switch {
  margin-bottom: 0;
}

.footer-actions {
  background: #f8f9fa;
  border-top: 1px solid #e9ecef;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .section-card {
    margin: 8px;
  }
  
  .section-content {
    padding: 12px 16px;
  }
  
  .info-card {
    margin-bottom: 12px;
  }
}

/* Dark theme support */
.theme--dark .form-container {
  background: #1e1e1e;
}

.theme--dark .section-card {
  background: #2d2d2d;
}

.theme--dark .section-header {
  background: #3a3a3a;
  border-bottom-color: #404040;
}

.theme--dark .info-card {
  background: #3a3a3a;
  border-color: #404040;
}

.theme--dark .switch-container {
  background: #3a3a3a;
  border-color: #404040;
}

.theme--dark .footer-actions {
  background: #2d2d2d;
  border-top-color: #404040;
}

.applications-container {
  background: white;
  border-radius: 6px;
  border: 1px solid #e9ecef;
  overflow: hidden;
}

.applications-table {
  border-radius: 6px;
}

.applications-table thead th {
  background: #f8f9fa;
  font-weight: 600;
  color: #495057;
  border-bottom: 2px solid #e9ecef;
  padding: 12px 8px;
  font-size: 12px;
}

.applications-table tbody td {
  padding: 8px;
  border-bottom: 1px solid #f1f3f4;
  font-size: 12px;
}

.applications-table tbody tr:hover {
  background: #f8f9fa;
}

.empty-state {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 130px;
  background: #fafafa;
  border: 2px dashed #e0e0e0;
  border-radius: 8px;
}

.empty-content {
  text-align: center;
  padding: 20px;
}

/* Responsive */
@media (max-width: 768px) {
  .applications-table {
    font-size: 11px;
  }
  
  .applications-table thead th,
  .applications-table tbody td {
    padding: 6px 4px;
  }
}

/* Dark theme */
.theme--dark .applications-container {
  background: #2d2d2d;
  border-color: #404040;
}

.theme--dark .applications-table thead th {
  background: #3a3a3a;
  border-bottom-color: #404040;
}

.theme--dark .applications-table tbody td {
  border-bottom-color: #404040;
}

.theme--dark .applications-table tbody tr:hover {
  background: #3a3a3a;
}

.theme--dark .empty-state {
  background: #2d2d2d;
  border-color: #404040;
}

/* Agregar al <style scoped> existente */

.phenology-stages-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
  /* margin-bottom: 16px; */
}

.phenology-stage-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 6px 12px;
  background: white;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  min-height: 48px;
}

.stage-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.stage-name {
  font-size: 13px;
  font-weight: 500;
  color: #212529;
  line-height: 1.2;
}

.stage-helper {
  font-size: 10px;
  color: #6c757d;
  font-style: italic;
  /* margin-top: 2px; */
  line-height: 1.1;
}

.stage-input {
  flex: 0 0 80px;
}

.phenology-total-compact {
  padding: 12px;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 6px;
}

.total-info {
  display: flex;
  align-items: center;
  gap: 8px;
  /* margin-bottom: 4px; */
}

.total-label {
  font-size: 13px;
  font-weight: 600;
  color: #495057;
}

.total-value {
  font-size: 14px;
  font-weight: 700;
  color: #28a745;
  transition: color 0.3s ease;
}

.total-value.error {
  color: #dc3545;
}

.future-sections {
  height: 100%;
  display: flex;
  align-items: center;
}

/* Responsive */
@media (max-width: 768px) {
  .phenology-stages-grid {
    gap: 6px;
  }
  
  .phenology-stage-item {
    padding: 4px 8px;
    min-height: 44px;
  }
  
  .stage-name {
    font-size: 12px;
  }
  
  .stage-helper {
    font-size: 9px;
  }
  
  .stage-input {
    flex: 0 0 70px;
  }
}

/* Dark theme */
.theme--dark .phenology-stage-item {
  background: #3a3a3a;
  border-color: #404040;
}

.theme--dark .stage-name {
  color: #e0e0e0;
}

.theme--dark .stage-helper {
  color: #b0b0b0;
}

.theme--dark .phenology-total-compact {
  background: #3a3a3a;
  border-color: #404040;
}

.theme--dark .total-label {
  color: #e0e0e0;
}

.evaluations-container {
  background: white;
  border-radius: 6px;
  border: 1px solid #e9ecef;
  overflow: hidden;
}

.evaluations-table {
  border-radius: 6px;
}

.evaluations-table thead th {
  background: #f8f9fa;
  font-weight: 600;
  color: #495057;
  border-bottom: 2px solid #e9ecef;
  padding: 12px 8px;
  font-size: 12px;
}

.evaluations-table tbody td {
  padding: 8px;
  border-bottom: 1px solid #f1f3f4;
  font-size: 12px;
}

.evaluations-table tbody tr:hover {
  background: #f8f9fa;
}

/* Dark theme */
.theme--dark .evaluations-container {
  background: #2d2d2d;
  border-color: #404040;
}

.theme--dark .evaluations-table thead th {
  background: #3a3a3a;
  border-bottom-color: #404040;
}

.theme--dark .evaluations-table tbody td {
  border-bottom-color: #404040;
}

.theme--dark .evaluations-table tbody tr:hover {
  background: #3a3a3a;
}

/* En tu sección de estilos */
.installation-switch {
  margin: 0;
  padding: 8px 0;
}
.installation-switch .v-input__control {
  justify-content: space-between;
}
.helper-circle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #0022cbce;
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  border-radius: 50%;
  width: 22px;
  height: 22px;
  margin-left: 6px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.08);
}
.recommendations-table-container {
  max-height: 400px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
}

.recommendations-table {
  background: white;
}

.empty-state {
  background-color: #fafafa;
  border-radius: 8px;
  border: 2px dashed #e0e0e0;
}

.border-top {
  border-top: 1px solid #e0e0e0;
}

.location-loader-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 20px;
}

.loader-text {
  margin-top: 0;
  color: #666;
  font-size: 14px;
  font-weight: 500;
  animation: text-fade 2s ease-in-out infinite;
  margin-bottom: 0px !important;
}

@keyframes text-fade {
  0%, 100% { opacity: 0.7; }
  50% { opacity: 1; }
}

/* Opción 1: Pulso con ondas */
.pulse-loader {
  position: relative;
  width: 40px;  /* en lugar de 60px */
  height: 40px;
}

.pulse-dot {
  position: absolute;
  width: 14px;  /* en lugar de 20px */
  height: 14px;
  background: #4f46e5;
  border-radius: 50%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  animation: pulse-dot 2s ease-in-out infinite;
}

.pulse-ring {
  position: absolute;
  width: 40px;  /* en lugar de 60px */
  height: 40px;
  border: 2px solid #4f46e5;
  border-radius: 50%;
  opacity: 0;
  top: 0;
  left: 0;
  animation: pulse-ring 2s ease-in-out infinite;
}

.pulse-ring:nth-child(2) { animation-delay: 0.5s; }
.pulse-ring:nth-child(3) { animation-delay: 1s; }
.pulse-ring:nth-child(4) { animation-delay: 1.5s; }

@keyframes pulse-dot {
  0%, 100% { 
    transform: translate(-50%, -50%) scale(1);
    background: #4f46e5;
  }
  50% { 
    transform: translate(-50%, -50%) scale(1.2);
    background: #6366f1;
  }
}

@keyframes pulse-ring {
  0% { 
    transform: scale(0.3); 
    opacity: 1; 
  }
  100% { 
    transform: scale(1.5); 
    opacity: 0; 
  }
}

/* Opción 2: Pin animado */
.pin-loader {
  animation: pin-bounce 1.5s ease-in-out infinite;
}

.pin-icon {
  color: #4f46e5;
  filter: drop-shadow(0 4px 8px rgba(79, 70, 229, 0.3));
}

@keyframes pin-bounce {
  0%, 100% { 
    transform: translateY(0) scale(1);
  }
  50% { 
    transform: translateY(-10px) scale(1.1);
  }
}

/* Opción 3: Radar circular */
.radar-loader {
  position: relative;
  width: 80px;
  height: 80px;
  margin: 0 auto;
}

.radar-circle {
  position: absolute;
  width: 80px;
  height: 80px;
  border: 2px solid #e5e7eb;
  border-radius: 50%;
  top: 0;
  left: 0;
}

.radar-circle::before,
.radar-circle::after {
  content: '';
  position: absolute;
  border: 1px solid #d1d5db;
  border-radius: 50%;
}

.radar-circle::before {
  width: 50px;
  height: 50px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.radar-circle::after {
  width: 20px;
  height: 20px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.radar-dot {
  position: absolute;
  width: 8px;
  height: 8px;
  background: #4f46e5;
  border-radius: 50%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
}

.radar-sweep {
  position: absolute;
  width: 40px;
  height: 2px;
  background: linear-gradient(90deg, transparent, #4f46e5);
  top: 50%;
  left: 50%;
  transform-origin: 0 50%;
  animation: radar-sweep 2s linear infinite;
}

@keyframes radar-sweep {
  0% { transform: translateX(-50%) rotate(0deg); }
  100% { transform: translateX(-50%) rotate(360deg); }
}

/* Responsive */
@media (max-width: 600px) {
  .location-loader-container {
    padding: 30px 15px;
    min-height: 150px;
    flex-direction: column;
    gap: 15px;
  }
  
  .loader-text {
    font-size: 13px;
    margin-top: 15px;
  }
}
</style>